import ds, { memo as er, useState as Q, useEffect as Ne, useCallback as bt, useMemo as kt, createContext as tr, useContext as st, useRef as sr, useReducer as mn } from "react";
import { NameCell as _n, DateCell as Fs, TabsNavigationNew as rr, FormElement as Se, FormActionsContainer as yn, SpinnerWidgetContainer as cs, HomePageWidgetList as gn, HomePageWidgetListItem as Bt, CodeEditor as Sn, FileExplorer as pn, ModuleDescriptionCard as wn, PageList as vn, ConfirmationDialog as xn } from "@prometheus/features";
import { useList as bn, useInterval as nr, ModalContext as ar, DialogContext as kn } from "@prometheus/hooks";
import { api as _e, getSortDirection as Mn, createMethodApiCreateListConfig as Dn, getSubmissionStatusInfo as ir, createSortingMethodListConfig as On, createFiltersPanelListConfig as Tn, createCrudMethodsListConfig as Yn, getReducerWithProduce as En, getFormatDateAndTime as or, getUUID as qt } from "@prometheus/utils";
import { useNavigate as lr, Routes as Rn, Route as Ls } from "react-router-dom";
import { StatusTag as ur, Tooltip as Ws, IconButton as As, Icon as it, Grid as R, Paper as fs, Spinner as ot, Block as dr, Select as Xe, Input as yt, Button as Mt, Box as Nn, EmptyTableStub as Us, useNotifications as In } from "@prometheus/components";
import { originSubmissions as cr, SubmissionStatus as se, CreateSubmissionFormTabs as Te, AnalysisTypes as Hs, analysisTypes as Gs, SubmissionResultTabs as rt } from "@prometheus/enums";
import { Status as U } from "@prometheus/types";
import Ie from "@emotion/styled";
var es = { exports: {} }, Ke = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zs;
function Cn() {
  if (zs) return Ke;
  zs = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function s(r, n, a) {
    var i = null;
    if (a !== void 0 && (i = "" + a), n.key !== void 0 && (i = "" + n.key), "key" in n) {
      a = {};
      for (var d in n)
        d !== "key" && (a[d] = n[d]);
    } else a = n;
    return n = a.ref, {
      $$typeof: e,
      type: r,
      key: i,
      ref: n !== void 0 ? n : null,
      props: a
    };
  }
  return Ke.Fragment = t, Ke.jsx = s, Ke.jsxs = s, Ke;
}
var Qe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vs;
function Pn() {
  return Vs || (Vs = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u) {
      if (u == null) return null;
      if (typeof u == "function")
        return u.$$typeof === G ? null : u.displayName || u.name || null;
      if (typeof u == "string") return u;
      switch (u) {
        case W:
          return "Fragment";
        case g:
          return "Profiler";
        case X:
          return "StrictMode";
        case Ae:
          return "Suspense";
        case Ue:
          return "SuspenseList";
        case j:
          return "Activity";
      }
      if (typeof u == "object")
        switch (typeof u.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), u.$$typeof) {
          case q:
            return "Portal";
          case T:
            return (u.displayName || "Context") + ".Provider";
          case E:
            return (u._context.displayName || "Context") + ".Consumer";
          case ie:
            var v = u.render;
            return u = u.displayName, u || (u = v.displayName || v.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
          case Ce:
            return v = u.displayName || null, v !== null ? v : e(u.type) || "Memo";
          case y:
            v = u._payload, u = u._init;
            try {
              return e(u(v));
            } catch {
            }
        }
      return null;
    }
    function t(u) {
      return "" + u;
    }
    function s(u) {
      try {
        t(u);
        var v = !1;
      } catch {
        v = !0;
      }
      if (v) {
        v = console;
        var P = v.error, z = typeof Symbol == "function" && Symbol.toStringTag && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return P.call(
          v,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          z
        ), t(u);
      }
    }
    function r(u) {
      if (u === W) return "<>";
      if (typeof u == "object" && u !== null && u.$$typeof === y)
        return "<...>";
      try {
        var v = e(u);
        return v ? "<" + v + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function n() {
      var u = L.A;
      return u === null ? null : u.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function i(u) {
      if (K.call(u, "key")) {
        var v = Object.getOwnPropertyDescriptor(u, "key").get;
        if (v && v.isReactWarning) return !1;
      }
      return u.key !== void 0;
    }
    function d(u, v) {
      function P() {
        A || (A = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          v
        ));
      }
      P.isReactWarning = !0, Object.defineProperty(u, "key", {
        get: P,
        configurable: !0
      });
    }
    function f() {
      var u = e(this.type);
      return Is[u] || (Is[u] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), u = this.props.ref, u !== void 0 ? u : null;
    }
    function m(u, v, P, z, Oe, fe, Vt, $t) {
      return P = fe.ref, u = {
        $$typeof: O,
        type: u,
        key: v,
        props: fe,
        _owner: Oe
      }, (P !== void 0 ? P : null) !== null ? Object.defineProperty(u, "ref", {
        enumerable: !1,
        get: f
      }) : Object.defineProperty(u, "ref", { enumerable: !1, value: null }), u._store = {}, Object.defineProperty(u._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(u, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(u, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Vt
      }), Object.defineProperty(u, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: $t
      }), Object.freeze && (Object.freeze(u.props), Object.freeze(u)), u;
    }
    function p(u, v, P, z, Oe, fe, Vt, $t) {
      var V = v.children;
      if (V !== void 0)
        if (z)
          if (_t(V)) {
            for (z = 0; z < V.length; z++)
              w(V[z]);
            Object.freeze && Object.freeze(V);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else w(V);
      if (K.call(v, "key")) {
        V = e(u);
        var He = Object.keys(v).filter(function(hn) {
          return hn !== "key";
        });
        z = 0 < He.length ? "{key: someKey, " + He.join(": ..., ") + ": ...}" : "{key: someKey}", js[V + z] || (He = 0 < He.length ? "{" + He.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          z,
          V,
          He,
          V
        ), js[V + z] = !0);
      }
      if (V = null, P !== void 0 && (s(P), V = "" + P), i(v) && (s(v.key), V = "" + v.key), "key" in v) {
        P = {};
        for (var Zt in v)
          Zt !== "key" && (P[Zt] = v[Zt]);
      } else P = v;
      return V && d(
        P,
        typeof u == "function" ? u.displayName || u.name || "Unknown" : u
      ), m(
        u,
        V,
        fe,
        Oe,
        n(),
        P,
        Vt,
        $t
      );
    }
    function w(u) {
      typeof u == "object" && u !== null && u.$$typeof === O && u._store && (u._store.validated = 1);
    }
    var D = ds, O = Symbol.for("react.transitional.element"), q = Symbol.for("react.portal"), W = Symbol.for("react.fragment"), X = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), E = Symbol.for("react.consumer"), T = Symbol.for("react.context"), ie = Symbol.for("react.forward_ref"), Ae = Symbol.for("react.suspense"), Ue = Symbol.for("react.suspense_list"), Ce = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), j = Symbol.for("react.activity"), G = Symbol.for("react.client.reference"), L = D.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = Object.prototype.hasOwnProperty, _t = Array.isArray, ce = console.createTask ? console.createTask : function() {
      return null;
    };
    D = {
      react_stack_bottom_frame: function(u) {
        return u();
      }
    };
    var A, Is = {}, Cs = D.react_stack_bottom_frame.bind(
      D,
      a
    )(), Ps = ce(r(a)), js = {};
    Qe.Fragment = W, Qe.jsx = function(u, v, P, z, Oe) {
      var fe = 1e4 > L.recentlyCreatedOwnerStacks++;
      return p(
        u,
        v,
        P,
        !1,
        z,
        Oe,
        fe ? Error("react-stack-top-frame") : Cs,
        fe ? ce(r(u)) : Ps
      );
    }, Qe.jsxs = function(u, v, P, z, Oe) {
      var fe = 1e4 > L.recentlyCreatedOwnerStacks++;
      return p(
        u,
        v,
        P,
        !0,
        z,
        Oe,
        fe ? Error("react-stack-top-frame") : Cs,
        fe ? ce(r(u)) : Ps
      );
    };
  }()), Qe;
}
process.env.NODE_ENV === "production" ? es.exports = Cn() : es.exports = Pn();
var o = es.exports;
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var fr;
function c() {
  return fr.apply(null, arguments);
}
function jn(e) {
  fr = e;
}
function le(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Fe(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function k(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function hs(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (k(e, t))
      return !1;
  return !0;
}
function J(e) {
  return e === void 0;
}
function ke(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function ct(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function hr(e, t) {
  var s = [], r, n = e.length;
  for (r = 0; r < n; ++r)
    s.push(t(e[r], r));
  return s;
}
function Ye(e, t) {
  for (var s in t)
    k(t, s) && (e[s] = t[s]);
  return k(t, "toString") && (e.toString = t.toString), k(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ye(e, t, s, r) {
  return Fr(e, t, s, r, !0).utc();
}
function Fn() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function S(e) {
  return e._pf == null && (e._pf = Fn()), e._pf;
}
var ts;
Array.prototype.some ? ts = Array.prototype.some : ts = function(e) {
  var t = Object(this), s = t.length >>> 0, r;
  for (r = 0; r < s; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function ms(e) {
  if (e._isValid == null) {
    var t = S(e), s = ts.call(t.parsedDateParts, function(n) {
      return n != null;
    }), r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && s);
    if (e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function It(e) {
  var t = ye(NaN);
  return e != null ? Ye(S(t), e) : S(t).userInvalidated = !0, t;
}
var $s = c.momentProperties = [], Jt = !1;
function _s(e, t) {
  var s, r, n, a = $s.length;
  if (J(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), J(t._i) || (e._i = t._i), J(t._f) || (e._f = t._f), J(t._l) || (e._l = t._l), J(t._strict) || (e._strict = t._strict), J(t._tzm) || (e._tzm = t._tzm), J(t._isUTC) || (e._isUTC = t._isUTC), J(t._offset) || (e._offset = t._offset), J(t._pf) || (e._pf = S(t)), J(t._locale) || (e._locale = t._locale), a > 0)
    for (s = 0; s < a; s++)
      r = $s[s], n = t[r], J(n) || (e[r] = n);
  return e;
}
function ft(e) {
  _s(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Jt === !1 && (Jt = !0, c.updateOffset(this), Jt = !1);
}
function ue(e) {
  return e instanceof ft || e != null && e._isAMomentObject != null;
}
function mr(e) {
  c.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ne(e, t) {
  var s = !0;
  return Ye(function() {
    if (c.deprecationHandler != null && c.deprecationHandler(null, e), s) {
      var r = [], n, a, i, d = arguments.length;
      for (a = 0; a < d; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (i in arguments[0])
            k(arguments[0], i) && (n += i + ": " + arguments[0][i] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        r.push(n);
      }
      mr(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), s = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Zs = {};
function _r(e, t) {
  c.deprecationHandler != null && c.deprecationHandler(e, t), Zs[e] || (mr(t), Zs[e] = !0);
}
c.suppressDeprecationWarnings = !1;
c.deprecationHandler = null;
function ge(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Ln(e) {
  var t, s;
  for (s in e)
    k(e, s) && (t = e[s], ge(t) ? this[s] = t : this["_" + s] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function ss(e, t) {
  var s = Ye({}, e), r;
  for (r in t)
    k(t, r) && (Fe(e[r]) && Fe(t[r]) ? (s[r] = {}, Ye(s[r], e[r]), Ye(s[r], t[r])) : t[r] != null ? s[r] = t[r] : delete s[r]);
  for (r in e)
    k(e, r) && !k(t, r) && Fe(e[r]) && (s[r] = Ye({}, s[r]));
  return s;
}
function ys(e) {
  e != null && this.set(e);
}
var rs;
Object.keys ? rs = Object.keys : rs = function(e) {
  var t, s = [];
  for (t in e)
    k(e, t) && s.push(t);
  return s;
};
var Wn = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function An(e, t, s) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return ge(r) ? r.call(t, s) : r;
}
function me(e, t, s) {
  var r = "" + Math.abs(e), n = t - r.length, a = e >= 0;
  return (a ? s ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + r;
}
var gs = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, gt = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Xt = {}, $e = {};
function _(e, t, s, r) {
  var n = r;
  typeof r == "string" && (n = function() {
    return this[r]();
  }), e && ($e[e] = n), t && ($e[t[0]] = function() {
    return me(n.apply(this, arguments), t[1], t[2]);
  }), s && ($e[s] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function Un(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Hn(e) {
  var t = e.match(gs), s, r;
  for (s = 0, r = t.length; s < r; s++)
    $e[t[s]] ? t[s] = $e[t[s]] : t[s] = Un(t[s]);
  return function(n) {
    var a = "", i;
    for (i = 0; i < r; i++)
      a += ge(t[i]) ? t[i].call(n, e) : t[i];
    return a;
  };
}
function pt(e, t) {
  return e.isValid() ? (t = yr(t, e.localeData()), Xt[t] = Xt[t] || Hn(t), Xt[t](e)) : e.localeData().invalidDate();
}
function yr(e, t) {
  var s = 5;
  function r(n) {
    return t.longDateFormat(n) || n;
  }
  for (gt.lastIndex = 0; s >= 0 && gt.test(e); )
    e = e.replace(
      gt,
      r
    ), gt.lastIndex = 0, s -= 1;
  return e;
}
var Gn = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function zn(e) {
  var t = this._longDateFormat[e], s = this._longDateFormat[e.toUpperCase()];
  return t || !s ? t : (this._longDateFormat[e] = s.match(gs).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var Vn = "Invalid date";
function $n() {
  return this._invalidDate;
}
var Zn = "%d", Bn = /\d{1,2}/;
function qn(e) {
  return this._ordinal.replace("%d", e);
}
var Jn = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Xn(e, t, s, r) {
  var n = this._relativeTime[s];
  return ge(n) ? n(e, t, s, r) : n.replace(/%d/i, e);
}
function Kn(e, t) {
  var s = this._relativeTime[e > 0 ? "future" : "past"];
  return ge(s) ? s(t) : s.replace(/%s/i, t);
}
var nt = {};
function Z(e, t) {
  var s = e.toLowerCase();
  nt[s] = nt[s + "s"] = nt[t] = e;
}
function ae(e) {
  return typeof e == "string" ? nt[e] || nt[e.toLowerCase()] : void 0;
}
function Ss(e) {
  var t = {}, s, r;
  for (r in e)
    k(e, r) && (s = ae(r), s && (t[s] = e[r]));
  return t;
}
var gr = {};
function B(e, t) {
  gr[e] = t;
}
function Qn(e) {
  var t = [], s;
  for (s in e)
    k(e, s) && t.push({ unit: s, priority: gr[s] });
  return t.sort(function(r, n) {
    return r.priority - n.priority;
  }), t;
}
function Ct(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function re(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function x(e) {
  var t = +e, s = 0;
  return t !== 0 && isFinite(t) && (s = re(t)), s;
}
function qe(e, t) {
  return function(s) {
    return s != null ? (Sr(this, e, s), c.updateOffset(this, t), this) : Dt(this, e);
  };
}
function Dt(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function Sr(e, t, s) {
  e.isValid() && !isNaN(s) && (t === "FullYear" && Ct(e.year()) && e.month() === 1 && e.date() === 29 ? (s = x(s), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    s,
    e.month(),
    At(s, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](s));
}
function ea(e) {
  return e = ae(e), ge(this[e]) ? this[e]() : this;
}
function ta(e, t) {
  if (typeof e == "object") {
    e = Ss(e);
    var s = Qn(e), r, n = s.length;
    for (r = 0; r < n; r++)
      this[s[r].unit](e[s[r].unit]);
  } else if (e = ae(e), ge(this[e]))
    return this[e](t);
  return this;
}
var pr = /\d/, te = /\d\d/, wr = /\d{3}/, ps = /\d{4}/, Pt = /[+-]?\d{6}/, I = /\d\d?/, vr = /\d\d\d\d?/, xr = /\d\d\d\d\d\d?/, jt = /\d{1,3}/, ws = /\d{1,4}/, Ft = /[+-]?\d{1,6}/, Je = /\d+/, Lt = /[+-]?\d+/, sa = /Z|[+-]\d\d:?\d\d/gi, Wt = /Z|[+-]\d\d(?::?\d\d)?/gi, ra = /[+-]?\d+(\.\d{1,3})?/, ht = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Ot;
Ot = {};
function h(e, t, s) {
  Ot[e] = ge(t) ? t : function(r, n) {
    return r && s ? s : t;
  };
}
function na(e, t) {
  return k(Ot, e) ? Ot[e](t._strict, t._locale) : new RegExp(aa(e));
}
function aa(e) {
  return ee(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, s, r, n, a) {
        return s || r || n || a;
      }
    )
  );
}
function ee(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var ns = {};
function Y(e, t) {
  var s, r = t, n;
  for (typeof e == "string" && (e = [e]), ke(t) && (r = function(a, i) {
    i[t] = x(a);
  }), n = e.length, s = 0; s < n; s++)
    ns[e[s]] = r;
}
function mt(e, t) {
  Y(e, function(s, r, n, a) {
    n._w = n._w || {}, t(s, n._w, n, a);
  });
}
function ia(e, t, s) {
  t != null && k(ns, e) && ns[e](t, s._a, s, e);
}
var $ = 0, ve = 1, he = 2, H = 3, oe = 4, xe = 5, je = 6, oa = 7, la = 8;
function ua(e, t) {
  return (e % t + t) % t;
}
var F;
Array.prototype.indexOf ? F = Array.prototype.indexOf : F = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function At(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var s = ua(t, 12);
  return e += (t - s) / 12, s === 1 ? Ct(e) ? 29 : 28 : 31 - s % 7 % 2;
}
_("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
_("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
_("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Z("month", "M");
B("month", 8);
h("M", I);
h("MM", I, te);
h("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
h("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
Y(["M", "MM"], function(e, t) {
  t[ve] = x(e) - 1;
});
Y(["MMM", "MMMM"], function(e, t, s, r) {
  var n = s._locale.monthsParse(e, r, s._strict);
  n != null ? t[ve] = n : S(s).invalidMonth = e;
});
var da = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), br = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), kr = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, ca = ht, fa = ht;
function ha(e, t) {
  return e ? le(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || kr).test(t) ? "format" : "standalone"][e.month()] : le(this._months) ? this._months : this._months.standalone;
}
function ma(e, t) {
  return e ? le(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[kr.test(t) ? "format" : "standalone"][e.month()] : le(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function _a(e, t, s) {
  var r, n, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      a = ye([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
  return s ? t === "MMM" ? (n = F.call(this._shortMonthsParse, i), n !== -1 ? n : null) : (n = F.call(this._longMonthsParse, i), n !== -1 ? n : null) : t === "MMM" ? (n = F.call(this._shortMonthsParse, i), n !== -1 ? n : (n = F.call(this._longMonthsParse, i), n !== -1 ? n : null)) : (n = F.call(this._longMonthsParse, i), n !== -1 ? n : (n = F.call(this._shortMonthsParse, i), n !== -1 ? n : null));
}
function ya(e, t, s) {
  var r, n, a;
  if (this._monthsParseExact)
    return _a.call(this, e, t, s);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (n = ye([2e3, r]), s && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !s && !this._monthsParse[r] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), s && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (s && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!s && this._monthsParse[r].test(e))
      return r;
  }
}
function Mr(e, t) {
  var s;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = x(t);
    else if (t = e.localeData().monthsParse(t), !ke(t))
      return e;
  }
  return s = Math.min(e.date(), At(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, s), e;
}
function Dr(e) {
  return e != null ? (Mr(this, e), c.updateOffset(this, !0), this) : Dt(this, "Month");
}
function ga() {
  return At(this.year(), this.month());
}
function Sa(e) {
  return this._monthsParseExact ? (k(this, "_monthsRegex") || Or.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (k(this, "_monthsShortRegex") || (this._monthsShortRegex = ca), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function pa(e) {
  return this._monthsParseExact ? (k(this, "_monthsRegex") || Or.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (k(this, "_monthsRegex") || (this._monthsRegex = fa), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Or() {
  function e(i, d) {
    return d.length - i.length;
  }
  var t = [], s = [], r = [], n, a;
  for (n = 0; n < 12; n++)
    a = ye([2e3, n]), t.push(this.monthsShort(a, "")), s.push(this.months(a, "")), r.push(this.months(a, "")), r.push(this.monthsShort(a, ""));
  for (t.sort(e), s.sort(e), r.sort(e), n = 0; n < 12; n++)
    t[n] = ee(t[n]), s[n] = ee(s[n]);
  for (n = 0; n < 24; n++)
    r[n] = ee(r[n]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
_("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? me(e, 4) : "+" + e;
});
_(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
_(0, ["YYYY", 4], 0, "year");
_(0, ["YYYYY", 5], 0, "year");
_(0, ["YYYYYY", 6, !0], 0, "year");
Z("year", "y");
B("year", 1);
h("Y", Lt);
h("YY", I, te);
h("YYYY", ws, ps);
h("YYYYY", Ft, Pt);
h("YYYYYY", Ft, Pt);
Y(["YYYYY", "YYYYYY"], $);
Y("YYYY", function(e, t) {
  t[$] = e.length === 2 ? c.parseTwoDigitYear(e) : x(e);
});
Y("YY", function(e, t) {
  t[$] = c.parseTwoDigitYear(e);
});
Y("Y", function(e, t) {
  t[$] = parseInt(e, 10);
});
function at(e) {
  return Ct(e) ? 366 : 365;
}
c.parseTwoDigitYear = function(e) {
  return x(e) + (x(e) > 68 ? 1900 : 2e3);
};
var Tr = qe("FullYear", !0);
function wa() {
  return Ct(this.year());
}
function va(e, t, s, r, n, a, i) {
  var d;
  return e < 100 && e >= 0 ? (d = new Date(e + 400, t, s, r, n, a, i), isFinite(d.getFullYear()) && d.setFullYear(e)) : d = new Date(e, t, s, r, n, a, i), d;
}
function lt(e) {
  var t, s;
  return e < 100 && e >= 0 ? (s = Array.prototype.slice.call(arguments), s[0] = e + 400, t = new Date(Date.UTC.apply(null, s)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Tt(e, t, s) {
  var r = 7 + t - s, n = (7 + lt(e, 0, r).getUTCDay() - t) % 7;
  return -n + r - 1;
}
function Yr(e, t, s, r, n) {
  var a = (7 + s - r) % 7, i = Tt(e, r, n), d = 1 + 7 * (t - 1) + a + i, f, m;
  return d <= 0 ? (f = e - 1, m = at(f) + d) : d > at(e) ? (f = e + 1, m = d - at(e)) : (f = e, m = d), {
    year: f,
    dayOfYear: m
  };
}
function ut(e, t, s) {
  var r = Tt(e.year(), t, s), n = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, a, i;
  return n < 1 ? (i = e.year() - 1, a = n + be(i, t, s)) : n > be(e.year(), t, s) ? (a = n - be(e.year(), t, s), i = e.year() + 1) : (i = e.year(), a = n), {
    week: a,
    year: i
  };
}
function be(e, t, s) {
  var r = Tt(e, t, s), n = Tt(e + 1, t, s);
  return (at(e) - r + n) / 7;
}
_("w", ["ww", 2], "wo", "week");
_("W", ["WW", 2], "Wo", "isoWeek");
Z("week", "w");
Z("isoWeek", "W");
B("week", 5);
B("isoWeek", 5);
h("w", I);
h("ww", I, te);
h("W", I);
h("WW", I, te);
mt(
  ["w", "ww", "W", "WW"],
  function(e, t, s, r) {
    t[r.substr(0, 1)] = x(e);
  }
);
function xa(e) {
  return ut(e, this._week.dow, this._week.doy).week;
}
var ba = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function ka() {
  return this._week.dow;
}
function Ma() {
  return this._week.doy;
}
function Da(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Oa(e) {
  var t = ut(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
_("d", 0, "do", "day");
_("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
_("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
_("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
_("e", 0, 0, "weekday");
_("E", 0, 0, "isoWeekday");
Z("day", "d");
Z("weekday", "e");
Z("isoWeekday", "E");
B("day", 11);
B("weekday", 11);
B("isoWeekday", 11);
h("d", I);
h("e", I);
h("E", I);
h("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
h("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
h("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
mt(["dd", "ddd", "dddd"], function(e, t, s, r) {
  var n = s._locale.weekdaysParse(e, r, s._strict);
  n != null ? t.d = n : S(s).invalidWeekday = e;
});
mt(["d", "e", "E"], function(e, t, s, r) {
  t[r] = x(e);
});
function Ta(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Ya(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function vs(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Ea = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Er = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Ra = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Na = ht, Ia = ht, Ca = ht;
function Pa(e, t) {
  var s = le(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? vs(s, this._week.dow) : e ? s[e.day()] : s;
}
function ja(e) {
  return e === !0 ? vs(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Fa(e) {
  return e === !0 ? vs(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function La(e, t, s) {
  var r, n, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      a = ye([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
  return s ? t === "dddd" ? (n = F.call(this._weekdaysParse, i), n !== -1 ? n : null) : t === "ddd" ? (n = F.call(this._shortWeekdaysParse, i), n !== -1 ? n : null) : (n = F.call(this._minWeekdaysParse, i), n !== -1 ? n : null) : t === "dddd" ? (n = F.call(this._weekdaysParse, i), n !== -1 || (n = F.call(this._shortWeekdaysParse, i), n !== -1) ? n : (n = F.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : t === "ddd" ? (n = F.call(this._shortWeekdaysParse, i), n !== -1 || (n = F.call(this._weekdaysParse, i), n !== -1) ? n : (n = F.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : (n = F.call(this._minWeekdaysParse, i), n !== -1 || (n = F.call(this._weekdaysParse, i), n !== -1) ? n : (n = F.call(this._shortWeekdaysParse, i), n !== -1 ? n : null));
}
function Wa(e, t, s) {
  var r, n, a;
  if (this._weekdaysParseExact)
    return La.call(this, e, t, s);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (n = ye([2e3, 1]).day(r), s && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), s && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (s && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (s && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!s && this._weekdaysParse[r].test(e))
      return r;
  }
}
function Aa(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Ta(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Ua(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Ha(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Ya(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Ga(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || xs.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (k(this, "_weekdaysRegex") || (this._weekdaysRegex = Na), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function za(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || xs.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (k(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ia), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Va(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || xs.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (k(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ca), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function xs() {
  function e(p, w) {
    return w.length - p.length;
  }
  var t = [], s = [], r = [], n = [], a, i, d, f, m;
  for (a = 0; a < 7; a++)
    i = ye([2e3, 1]).day(a), d = ee(this.weekdaysMin(i, "")), f = ee(this.weekdaysShort(i, "")), m = ee(this.weekdays(i, "")), t.push(d), s.push(f), r.push(m), n.push(d), n.push(f), n.push(m);
  t.sort(e), s.sort(e), r.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function bs() {
  return this.hours() % 12 || 12;
}
function $a() {
  return this.hours() || 24;
}
_("H", ["HH", 2], 0, "hour");
_("h", ["hh", 2], 0, bs);
_("k", ["kk", 2], 0, $a);
_("hmm", 0, 0, function() {
  return "" + bs.apply(this) + me(this.minutes(), 2);
});
_("hmmss", 0, 0, function() {
  return "" + bs.apply(this) + me(this.minutes(), 2) + me(this.seconds(), 2);
});
_("Hmm", 0, 0, function() {
  return "" + this.hours() + me(this.minutes(), 2);
});
_("Hmmss", 0, 0, function() {
  return "" + this.hours() + me(this.minutes(), 2) + me(this.seconds(), 2);
});
function Rr(e, t) {
  _(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
Rr("a", !0);
Rr("A", !1);
Z("hour", "h");
B("hour", 13);
function Nr(e, t) {
  return t._meridiemParse;
}
h("a", Nr);
h("A", Nr);
h("H", I);
h("h", I);
h("k", I);
h("HH", I, te);
h("hh", I, te);
h("kk", I, te);
h("hmm", vr);
h("hmmss", xr);
h("Hmm", vr);
h("Hmmss", xr);
Y(["H", "HH"], H);
Y(["k", "kk"], function(e, t, s) {
  var r = x(e);
  t[H] = r === 24 ? 0 : r;
});
Y(["a", "A"], function(e, t, s) {
  s._isPm = s._locale.isPM(e), s._meridiem = e;
});
Y(["h", "hh"], function(e, t, s) {
  t[H] = x(e), S(s).bigHour = !0;
});
Y("hmm", function(e, t, s) {
  var r = e.length - 2;
  t[H] = x(e.substr(0, r)), t[oe] = x(e.substr(r)), S(s).bigHour = !0;
});
Y("hmmss", function(e, t, s) {
  var r = e.length - 4, n = e.length - 2;
  t[H] = x(e.substr(0, r)), t[oe] = x(e.substr(r, 2)), t[xe] = x(e.substr(n)), S(s).bigHour = !0;
});
Y("Hmm", function(e, t, s) {
  var r = e.length - 2;
  t[H] = x(e.substr(0, r)), t[oe] = x(e.substr(r));
});
Y("Hmmss", function(e, t, s) {
  var r = e.length - 4, n = e.length - 2;
  t[H] = x(e.substr(0, r)), t[oe] = x(e.substr(r, 2)), t[xe] = x(e.substr(n));
});
function Za(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Ba = /[ap]\.?m?\.?/i, qa = qe("Hours", !0);
function Ja(e, t, s) {
  return e > 11 ? s ? "pm" : "PM" : s ? "am" : "AM";
}
var Ir = {
  calendar: Wn,
  longDateFormat: Gn,
  invalidDate: Vn,
  ordinal: Zn,
  dayOfMonthOrdinalParse: Bn,
  relativeTime: Jn,
  months: da,
  monthsShort: br,
  week: ba,
  weekdays: Ea,
  weekdaysMin: Ra,
  weekdaysShort: Er,
  meridiemParse: Ba
}, C = {}, et = {}, dt;
function Xa(e, t) {
  var s, r = Math.min(e.length, t.length);
  for (s = 0; s < r; s += 1)
    if (e[s] !== t[s])
      return s;
  return r;
}
function Bs(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Ka(e) {
  for (var t = 0, s, r, n, a; t < e.length; ) {
    for (a = Bs(e[t]).split("-"), s = a.length, r = Bs(e[t + 1]), r = r ? r.split("-") : null; s > 0; ) {
      if (n = Ut(a.slice(0, s).join("-")), n)
        return n;
      if (r && r.length >= s && Xa(a, r) >= s - 1)
        break;
      s--;
    }
    t++;
  }
  return dt;
}
function Qa(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Ut(e) {
  var t = null, s;
  if (C[e] === void 0 && typeof module < "u" && module && module.exports && Qa(e))
    try {
      t = dt._abbr, s = require, s("./locale/" + e), Re(t);
    } catch {
      C[e] = null;
    }
  return C[e];
}
function Re(e, t) {
  var s;
  return e && (J(t) ? s = Me(e) : s = ks(e, t), s ? dt = s : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), dt._abbr;
}
function ks(e, t) {
  if (t !== null) {
    var s, r = Ir;
    if (t.abbr = e, C[e] != null)
      _r(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = C[e]._config;
    else if (t.parentLocale != null)
      if (C[t.parentLocale] != null)
        r = C[t.parentLocale]._config;
      else if (s = Ut(t.parentLocale), s != null)
        r = s._config;
      else
        return et[t.parentLocale] || (et[t.parentLocale] = []), et[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return C[e] = new ys(ss(r, t)), et[e] && et[e].forEach(function(n) {
      ks(n.name, n.config);
    }), Re(e), C[e];
  } else
    return delete C[e], null;
}
function ei(e, t) {
  if (t != null) {
    var s, r, n = Ir;
    C[e] != null && C[e].parentLocale != null ? C[e].set(ss(C[e]._config, t)) : (r = Ut(e), r != null && (n = r._config), t = ss(n, t), r == null && (t.abbr = e), s = new ys(t), s.parentLocale = C[e], C[e] = s), Re(e);
  } else
    C[e] != null && (C[e].parentLocale != null ? (C[e] = C[e].parentLocale, e === Re() && Re(e)) : C[e] != null && delete C[e]);
  return C[e];
}
function Me(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return dt;
  if (!le(e)) {
    if (t = Ut(e), t)
      return t;
    e = [e];
  }
  return Ka(e);
}
function ti() {
  return rs(C);
}
function Ms(e) {
  var t, s = e._a;
  return s && S(e).overflow === -2 && (t = s[ve] < 0 || s[ve] > 11 ? ve : s[he] < 1 || s[he] > At(s[$], s[ve]) ? he : s[H] < 0 || s[H] > 24 || s[H] === 24 && (s[oe] !== 0 || s[xe] !== 0 || s[je] !== 0) ? H : s[oe] < 0 || s[oe] > 59 ? oe : s[xe] < 0 || s[xe] > 59 ? xe : s[je] < 0 || s[je] > 999 ? je : -1, S(e)._overflowDayOfYear && (t < $ || t > he) && (t = he), S(e)._overflowWeeks && t === -1 && (t = oa), S(e)._overflowWeekday && t === -1 && (t = la), S(e).overflow = t), e;
}
var si = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ri = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ni = /Z|[+-]\d\d(?::?\d\d)?/, St = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Kt = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], ai = /^\/?Date\((-?\d+)/i, ii = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, oi = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Cr(e) {
  var t, s, r = e._i, n = si.exec(r) || ri.exec(r), a, i, d, f, m = St.length, p = Kt.length;
  if (n) {
    for (S(e).iso = !0, t = 0, s = m; t < s; t++)
      if (St[t][1].exec(n[1])) {
        i = St[t][0], a = St[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (t = 0, s = p; t < s; t++)
        if (Kt[t][1].exec(n[3])) {
          d = (n[2] || " ") + Kt[t][0];
          break;
        }
      if (d == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && d != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if (ni.exec(n[4]))
        f = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (d || "") + (f || ""), Os(e);
  } else
    e._isValid = !1;
}
function li(e, t, s, r, n, a) {
  var i = [
    ui(e),
    br.indexOf(t),
    parseInt(s, 10),
    parseInt(r, 10),
    parseInt(n, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function ui(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function di(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function ci(e, t, s) {
  if (e) {
    var r = Er.indexOf(e), n = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== n)
      return S(s).weekdayMismatch = !0, s._isValid = !1, !1;
  }
  return !0;
}
function fi(e, t, s) {
  if (e)
    return oi[e];
  if (t)
    return 0;
  var r = parseInt(s, 10), n = r % 100, a = (r - n) / 100;
  return a * 60 + n;
}
function Pr(e) {
  var t = ii.exec(di(e._i)), s;
  if (t) {
    if (s = li(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !ci(t[1], s, e))
      return;
    e._a = s, e._tzm = fi(t[8], t[9], t[10]), e._d = lt.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), S(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function hi(e) {
  var t = ai.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Cr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Pr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : c.createFromInputFallback(e);
}
c.createFromInputFallback = ne(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function ze(e, t, s) {
  return e ?? t ?? s;
}
function mi(e) {
  var t = new Date(c.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function Ds(e) {
  var t, s, r = [], n, a, i;
  if (!e._d) {
    for (n = mi(e), e._w && e._a[he] == null && e._a[ve] == null && _i(e), e._dayOfYear != null && (i = ze(e._a[$], n[$]), (e._dayOfYear > at(i) || e._dayOfYear === 0) && (S(e)._overflowDayOfYear = !0), s = lt(i, 0, e._dayOfYear), e._a[ve] = s.getUTCMonth(), e._a[he] = s.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = n[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[H] === 24 && e._a[oe] === 0 && e._a[xe] === 0 && e._a[je] === 0 && (e._nextDay = !0, e._a[H] = 0), e._d = (e._useUTC ? lt : va).apply(
      null,
      r
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[H] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (S(e).weekdayMismatch = !0);
  }
}
function _i(e) {
  var t, s, r, n, a, i, d, f, m;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, i = 4, s = ze(
    t.GG,
    e._a[$],
    ut(N(), 1, 4).year
  ), r = ze(t.W, 1), n = ze(t.E, 1), (n < 1 || n > 7) && (f = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, m = ut(N(), a, i), s = ze(t.gg, e._a[$], m.year), r = ze(t.w, m.week), t.d != null ? (n = t.d, (n < 0 || n > 6) && (f = !0)) : t.e != null ? (n = t.e + a, (t.e < 0 || t.e > 6) && (f = !0)) : n = a), r < 1 || r > be(s, a, i) ? S(e)._overflowWeeks = !0 : f != null ? S(e)._overflowWeekday = !0 : (d = Yr(s, r, n, a, i), e._a[$] = d.year, e._dayOfYear = d.dayOfYear);
}
c.ISO_8601 = function() {
};
c.RFC_2822 = function() {
};
function Os(e) {
  if (e._f === c.ISO_8601) {
    Cr(e);
    return;
  }
  if (e._f === c.RFC_2822) {
    Pr(e);
    return;
  }
  e._a = [], S(e).empty = !0;
  var t = "" + e._i, s, r, n, a, i, d = t.length, f = 0, m, p;
  for (n = yr(e._f, e._locale).match(gs) || [], p = n.length, s = 0; s < p; s++)
    a = n[s], r = (t.match(na(a, e)) || [])[0], r && (i = t.substr(0, t.indexOf(r)), i.length > 0 && S(e).unusedInput.push(i), t = t.slice(
      t.indexOf(r) + r.length
    ), f += r.length), $e[a] ? (r ? S(e).empty = !1 : S(e).unusedTokens.push(a), ia(a, r, e)) : e._strict && !r && S(e).unusedTokens.push(a);
  S(e).charsLeftOver = d - f, t.length > 0 && S(e).unusedInput.push(t), e._a[H] <= 12 && S(e).bigHour === !0 && e._a[H] > 0 && (S(e).bigHour = void 0), S(e).parsedDateParts = e._a.slice(0), S(e).meridiem = e._meridiem, e._a[H] = yi(
    e._locale,
    e._a[H],
    e._meridiem
  ), m = S(e).era, m !== null && (e._a[$] = e._locale.erasConvertYear(m, e._a[$])), Ds(e), Ms(e);
}
function yi(e, t, s) {
  var r;
  return s == null ? t : e.meridiemHour != null ? e.meridiemHour(t, s) : (e.isPM != null && (r = e.isPM(s), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function gi(e) {
  var t, s, r, n, a, i, d = !1, f = e._f.length;
  if (f === 0) {
    S(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (n = 0; n < f; n++)
    a = 0, i = !1, t = _s({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[n], Os(t), ms(t) && (i = !0), a += S(t).charsLeftOver, a += S(t).unusedTokens.length * 10, S(t).score = a, d ? a < r && (r = a, s = t) : (r == null || a < r || i) && (r = a, s = t, i && (d = !0));
  Ye(e, s || t);
}
function Si(e) {
  if (!e._d) {
    var t = Ss(e._i), s = t.day === void 0 ? t.date : t.day;
    e._a = hr(
      [t.year, t.month, s, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), Ds(e);
  }
}
function pi(e) {
  var t = new ft(Ms(jr(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function jr(e) {
  var t = e._i, s = e._f;
  return e._locale = e._locale || Me(e._l), t === null || s === void 0 && t === "" ? It({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), ue(t) ? new ft(Ms(t)) : (ct(t) ? e._d = t : le(s) ? gi(e) : s ? Os(e) : wi(e), ms(e) || (e._d = null), e));
}
function wi(e) {
  var t = e._i;
  J(t) ? e._d = new Date(c.now()) : ct(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? hi(e) : le(t) ? (e._a = hr(t.slice(0), function(s) {
    return parseInt(s, 10);
  }), Ds(e)) : Fe(t) ? Si(e) : ke(t) ? e._d = new Date(t) : c.createFromInputFallback(e);
}
function Fr(e, t, s, r, n) {
  var a = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (s === !0 || s === !1) && (r = s, s = void 0), (Fe(e) && hs(e) || le(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = s, a._i = e, a._f = t, a._strict = r, pi(a);
}
function N(e, t, s, r) {
  return Fr(e, t, s, r, !1);
}
var vi = ne(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = N.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : It();
  }
), xi = ne(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = N.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : It();
  }
);
function Lr(e, t) {
  var s, r;
  if (t.length === 1 && le(t[0]) && (t = t[0]), !t.length)
    return N();
  for (s = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](s)) && (s = t[r]);
  return s;
}
function bi() {
  var e = [].slice.call(arguments, 0);
  return Lr("isBefore", e);
}
function ki() {
  var e = [].slice.call(arguments, 0);
  return Lr("isAfter", e);
}
var Mi = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, tt = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Di(e) {
  var t, s = !1, r, n = tt.length;
  for (t in e)
    if (k(e, t) && !(F.call(tt, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < n; ++r)
    if (e[tt[r]]) {
      if (s)
        return !1;
      parseFloat(e[tt[r]]) !== x(e[tt[r]]) && (s = !0);
    }
  return !0;
}
function Oi() {
  return this._isValid;
}
function Ti() {
  return de(NaN);
}
function Ht(e) {
  var t = Ss(e), s = t.year || 0, r = t.quarter || 0, n = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, d = t.hour || 0, f = t.minute || 0, m = t.second || 0, p = t.millisecond || 0;
  this._isValid = Di(t), this._milliseconds = +p + m * 1e3 + // 1000
  f * 6e4 + // 1000 * 60
  d * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +n + r * 3 + s * 12, this._data = {}, this._locale = Me(), this._bubble();
}
function wt(e) {
  return e instanceof Ht;
}
function as(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Yi(e, t, s) {
  var r = Math.min(e.length, t.length), n = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < r; i++)
    x(e[i]) !== x(t[i]) && a++;
  return a + n;
}
function Wr(e, t) {
  _(e, 0, 0, function() {
    var s = this.utcOffset(), r = "+";
    return s < 0 && (s = -s, r = "-"), r + me(~~(s / 60), 2) + t + me(~~s % 60, 2);
  });
}
Wr("Z", ":");
Wr("ZZ", "");
h("Z", Wt);
h("ZZ", Wt);
Y(["Z", "ZZ"], function(e, t, s) {
  s._useUTC = !0, s._tzm = Ts(Wt, e);
});
var Ei = /([\+\-]|\d\d)/gi;
function Ts(e, t) {
  var s = (t || "").match(e), r, n, a;
  return s === null ? null : (r = s[s.length - 1] || [], n = (r + "").match(Ei) || ["-", 0, 0], a = +(n[1] * 60) + x(n[2]), a === 0 ? 0 : n[0] === "+" ? a : -a);
}
function Ys(e, t) {
  var s, r;
  return t._isUTC ? (s = t.clone(), r = (ue(e) || ct(e) ? e.valueOf() : N(e).valueOf()) - s.valueOf(), s._d.setTime(s._d.valueOf() + r), c.updateOffset(s, !1), s) : N(e).local();
}
function is(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
c.updateOffset = function() {
};
function Ri(e, t, s) {
  var r = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Ts(Wt, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !s && (e = e * 60);
    return !this._isUTC && t && (n = is(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), r !== e && (!t || this._changeInProgress ? Hr(
      this,
      de(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : is(this);
}
function Ni(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Ii(e) {
  return this.utcOffset(0, e);
}
function Ci(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(is(this), "m")), this;
}
function Pi() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Ts(sa, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function ji(e) {
  return this.isValid() ? (e = e ? N(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Fi() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Li() {
  if (!J(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return _s(e, this), e = jr(e), e._a ? (t = e._isUTC ? ye(e._a) : N(e._a), this._isDSTShifted = this.isValid() && Yi(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Wi() {
  return this.isValid() ? !this._isUTC : !1;
}
function Ai() {
  return this.isValid() ? this._isUTC : !1;
}
function Ar() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Ui = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Hi = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function de(e, t) {
  var s = e, r = null, n, a, i;
  return wt(e) ? s = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : ke(e) || !isNaN(+e) ? (s = {}, t ? s[t] = +e : s.milliseconds = +e) : (r = Ui.exec(e)) ? (n = r[1] === "-" ? -1 : 1, s = {
    y: 0,
    d: x(r[he]) * n,
    h: x(r[H]) * n,
    m: x(r[oe]) * n,
    s: x(r[xe]) * n,
    ms: x(as(r[je] * 1e3)) * n
    // the millisecond decimal point is included in the match
  }) : (r = Hi.exec(e)) ? (n = r[1] === "-" ? -1 : 1, s = {
    y: Pe(r[2], n),
    M: Pe(r[3], n),
    w: Pe(r[4], n),
    d: Pe(r[5], n),
    h: Pe(r[6], n),
    m: Pe(r[7], n),
    s: Pe(r[8], n)
  }) : s == null ? s = {} : typeof s == "object" && ("from" in s || "to" in s) && (i = Gi(
    N(s.from),
    N(s.to)
  ), s = {}, s.ms = i.milliseconds, s.M = i.months), a = new Ht(s), wt(e) && k(e, "_locale") && (a._locale = e._locale), wt(e) && k(e, "_isValid") && (a._isValid = e._isValid), a;
}
de.fn = Ht.prototype;
de.invalid = Ti;
function Pe(e, t) {
  var s = e && parseFloat(e.replace(",", "."));
  return (isNaN(s) ? 0 : s) * t;
}
function qs(e, t) {
  var s = {};
  return s.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(s.months, "M").isAfter(t) && --s.months, s.milliseconds = +t - +e.clone().add(s.months, "M"), s;
}
function Gi(e, t) {
  var s;
  return e.isValid() && t.isValid() ? (t = Ys(t, e), e.isBefore(t) ? s = qs(e, t) : (s = qs(t, e), s.milliseconds = -s.milliseconds, s.months = -s.months), s) : { milliseconds: 0, months: 0 };
}
function Ur(e, t) {
  return function(s, r) {
    var n, a;
    return r !== null && !isNaN(+r) && (_r(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = s, s = r, r = a), n = de(s, r), Hr(this, n, e), this;
  };
}
function Hr(e, t, s, r) {
  var n = t._milliseconds, a = as(t._days), i = as(t._months);
  e.isValid() && (r = r ?? !0, i && Mr(e, Dt(e, "Month") + i * s), a && Sr(e, "Date", Dt(e, "Date") + a * s), n && e._d.setTime(e._d.valueOf() + n * s), r && c.updateOffset(e, a || i));
}
var zi = Ur(1, "add"), Vi = Ur(-1, "subtract");
function Gr(e) {
  return typeof e == "string" || e instanceof String;
}
function $i(e) {
  return ue(e) || ct(e) || Gr(e) || ke(e) || Bi(e) || Zi(e) || e === null || e === void 0;
}
function Zi(e) {
  var t = Fe(e) && !hs(e), s = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, i = r.length;
  for (n = 0; n < i; n += 1)
    a = r[n], s = s || k(e, a);
  return t && s;
}
function Bi(e) {
  var t = le(e), s = !1;
  return t && (s = e.filter(function(r) {
    return !ke(r) && Gr(e);
  }).length === 0), t && s;
}
function qi(e) {
  var t = Fe(e) && !hs(e), s = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < r.length; n += 1)
    a = r[n], s = s || k(e, a);
  return t && s;
}
function Ji(e, t) {
  var s = e.diff(t, "days", !0);
  return s < -6 ? "sameElse" : s < -1 ? "lastWeek" : s < 0 ? "lastDay" : s < 1 ? "sameDay" : s < 2 ? "nextDay" : s < 7 ? "nextWeek" : "sameElse";
}
function Xi(e, t) {
  arguments.length === 1 && (arguments[0] ? $i(arguments[0]) ? (e = arguments[0], t = void 0) : qi(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var s = e || N(), r = Ys(s, this).startOf("day"), n = c.calendarFormat(this, r) || "sameElse", a = t && (ge(t[n]) ? t[n].call(this, s) : t[n]);
  return this.format(
    a || this.localeData().calendar(n, this, N(s))
  );
}
function Ki() {
  return new ft(this);
}
function Qi(e, t) {
  var s = ue(e) ? e : N(e);
  return this.isValid() && s.isValid() ? (t = ae(t) || "millisecond", t === "millisecond" ? this.valueOf() > s.valueOf() : s.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function eo(e, t) {
  var s = ue(e) ? e : N(e);
  return this.isValid() && s.isValid() ? (t = ae(t) || "millisecond", t === "millisecond" ? this.valueOf() < s.valueOf() : this.clone().endOf(t).valueOf() < s.valueOf()) : !1;
}
function to(e, t, s, r) {
  var n = ue(e) ? e : N(e), a = ue(t) ? t : N(t);
  return this.isValid() && n.isValid() && a.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(n, s) : !this.isBefore(n, s)) && (r[1] === ")" ? this.isBefore(a, s) : !this.isAfter(a, s))) : !1;
}
function so(e, t) {
  var s = ue(e) ? e : N(e), r;
  return this.isValid() && s.isValid() ? (t = ae(t) || "millisecond", t === "millisecond" ? this.valueOf() === s.valueOf() : (r = s.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function ro(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function no(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function ao(e, t, s) {
  var r, n, a;
  if (!this.isValid())
    return NaN;
  if (r = Ys(e, this), !r.isValid())
    return NaN;
  switch (n = (r.utcOffset() - this.utcOffset()) * 6e4, t = ae(t), t) {
    case "year":
      a = vt(this, r) / 12;
      break;
    case "month":
      a = vt(this, r);
      break;
    case "quarter":
      a = vt(this, r) / 3;
      break;
    case "second":
      a = (this - r) / 1e3;
      break;
    case "minute":
      a = (this - r) / 6e4;
      break;
    case "hour":
      a = (this - r) / 36e5;
      break;
    case "day":
      a = (this - r - n) / 864e5;
      break;
    case "week":
      a = (this - r - n) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return s ? a : re(a);
}
function vt(e, t) {
  if (e.date() < t.date())
    return -vt(t, e);
  var s = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(s, "months"), n, a;
  return t - r < 0 ? (n = e.clone().add(s - 1, "months"), a = (t - r) / (r - n)) : (n = e.clone().add(s + 1, "months"), a = (t - r) / (n - r)), -(s + a) || 0;
}
c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function io() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function oo(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, s = t ? this.clone().utc() : this;
  return s.year() < 0 || s.year() > 9999 ? pt(
    s,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ge(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", pt(s, "Z")) : pt(
    s,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function lo() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", s, r, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), s = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(s + r + n + a);
}
function uo(e) {
  e || (e = this.isUtc() ? c.defaultFormatUtc : c.defaultFormat);
  var t = pt(this, e);
  return this.localeData().postformat(t);
}
function co(e, t) {
  return this.isValid() && (ue(e) && e.isValid() || N(e).isValid()) ? de({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function fo(e) {
  return this.from(N(), e);
}
function ho(e, t) {
  return this.isValid() && (ue(e) && e.isValid() || N(e).isValid()) ? de({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function mo(e) {
  return this.to(N(), e);
}
function zr(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Me(e), t != null && (this._locale = t), this);
}
var Vr = ne(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function $r() {
  return this._locale;
}
var Yt = 1e3, Ze = 60 * Yt, Et = 60 * Ze, Zr = (365 * 400 + 97) * 24 * Et;
function Be(e, t) {
  return (e % t + t) % t;
}
function Br(e, t, s) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, s) - Zr : new Date(e, t, s).valueOf();
}
function qr(e, t, s) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, s) - Zr : Date.UTC(e, t, s);
}
function _o(e) {
  var t, s;
  if (e = ae(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (s = this._isUTC ? qr : Br, e) {
    case "year":
      t = s(this.year(), 0, 1);
      break;
    case "quarter":
      t = s(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = s(this.year(), this.month(), 1);
      break;
    case "week":
      t = s(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = s(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = s(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Be(
        t + (this._isUTC ? 0 : this.utcOffset() * Ze),
        Et
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Be(t, Ze);
      break;
    case "second":
      t = this._d.valueOf(), t -= Be(t, Yt);
      break;
  }
  return this._d.setTime(t), c.updateOffset(this, !0), this;
}
function yo(e) {
  var t, s;
  if (e = ae(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (s = this._isUTC ? qr : Br, e) {
    case "year":
      t = s(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = s(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = s(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = s(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = s(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = s(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Et - Be(
        t + (this._isUTC ? 0 : this.utcOffset() * Ze),
        Et
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Ze - Be(t, Ze) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Yt - Be(t, Yt) - 1;
      break;
  }
  return this._d.setTime(t), c.updateOffset(this, !0), this;
}
function go() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function So() {
  return Math.floor(this.valueOf() / 1e3);
}
function po() {
  return new Date(this.valueOf());
}
function wo() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function vo() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function xo() {
  return this.isValid() ? this.toISOString() : null;
}
function bo() {
  return ms(this);
}
function ko() {
  return Ye({}, S(this));
}
function Mo() {
  return S(this).overflow;
}
function Do() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
_("N", 0, 0, "eraAbbr");
_("NN", 0, 0, "eraAbbr");
_("NNN", 0, 0, "eraAbbr");
_("NNNN", 0, 0, "eraName");
_("NNNNN", 0, 0, "eraNarrow");
_("y", ["y", 1], "yo", "eraYear");
_("y", ["yy", 2], 0, "eraYear");
_("y", ["yyy", 3], 0, "eraYear");
_("y", ["yyyy", 4], 0, "eraYear");
h("N", Es);
h("NN", Es);
h("NNN", Es);
h("NNNN", Fo);
h("NNNNN", Lo);
Y(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, s, r) {
    var n = s._locale.erasParse(e, r, s._strict);
    n ? S(s).era = n : S(s).invalidEra = e;
  }
);
h("y", Je);
h("yy", Je);
h("yyy", Je);
h("yyyy", Je);
h("yo", Wo);
Y(["y", "yy", "yyy", "yyyy"], $);
Y(["yo"], function(e, t, s, r) {
  var n;
  s._locale._eraYearOrdinalRegex && (n = e.match(s._locale._eraYearOrdinalRegex)), s._locale.eraYearOrdinalParse ? t[$] = s._locale.eraYearOrdinalParse(e, n) : t[$] = parseInt(e, 10);
});
function Oo(e, t) {
  var s, r, n, a = this._eras || Me("en")._eras;
  for (s = 0, r = a.length; s < r; ++s) {
    switch (typeof a[s].since) {
      case "string":
        n = c(a[s].since).startOf("day"), a[s].since = n.valueOf();
        break;
    }
    switch (typeof a[s].until) {
      case "undefined":
        a[s].until = 1 / 0;
        break;
      case "string":
        n = c(a[s].until).startOf("day").valueOf(), a[s].until = n.valueOf();
        break;
    }
  }
  return a;
}
function To(e, t, s) {
  var r, n, a = this.eras(), i, d, f;
  for (e = e.toUpperCase(), r = 0, n = a.length; r < n; ++r)
    if (i = a[r].name.toUpperCase(), d = a[r].abbr.toUpperCase(), f = a[r].narrow.toUpperCase(), s)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (d === e)
            return a[r];
          break;
        case "NNNN":
          if (i === e)
            return a[r];
          break;
        case "NNNNN":
          if (f === e)
            return a[r];
          break;
      }
    else if ([i, d, f].indexOf(e) >= 0)
      return a[r];
}
function Yo(e, t) {
  var s = e.since <= e.until ? 1 : -1;
  return t === void 0 ? c(e.since).year() : c(e.since).year() + (t - e.offset) * s;
}
function Eo() {
  var e, t, s, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), r[e].since <= s && s <= r[e].until || r[e].until <= s && s <= r[e].since)
      return r[e].name;
  return "";
}
function Ro() {
  var e, t, s, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), r[e].since <= s && s <= r[e].until || r[e].until <= s && s <= r[e].since)
      return r[e].narrow;
  return "";
}
function No() {
  var e, t, s, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), r[e].since <= s && s <= r[e].until || r[e].until <= s && s <= r[e].since)
      return r[e].abbr;
  return "";
}
function Io() {
  var e, t, s, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (s = n[e].since <= n[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return (this.year() - c(n[e].since).year()) * s + n[e].offset;
  return this.year();
}
function Co(e) {
  return k(this, "_erasNameRegex") || Rs.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Po(e) {
  return k(this, "_erasAbbrRegex") || Rs.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function jo(e) {
  return k(this, "_erasNarrowRegex") || Rs.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Es(e, t) {
  return t.erasAbbrRegex(e);
}
function Fo(e, t) {
  return t.erasNameRegex(e);
}
function Lo(e, t) {
  return t.erasNarrowRegex(e);
}
function Wo(e, t) {
  return t._eraYearOrdinalRegex || Je;
}
function Rs() {
  var e = [], t = [], s = [], r = [], n, a, i = this.eras();
  for (n = 0, a = i.length; n < a; ++n)
    t.push(ee(i[n].name)), e.push(ee(i[n].abbr)), s.push(ee(i[n].narrow)), r.push(ee(i[n].name)), r.push(ee(i[n].abbr)), r.push(ee(i[n].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  );
}
_(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
_(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Gt(e, t) {
  _(0, [e, e.length], 0, t);
}
Gt("gggg", "weekYear");
Gt("ggggg", "weekYear");
Gt("GGGG", "isoWeekYear");
Gt("GGGGG", "isoWeekYear");
Z("weekYear", "gg");
Z("isoWeekYear", "GG");
B("weekYear", 1);
B("isoWeekYear", 1);
h("G", Lt);
h("g", Lt);
h("GG", I, te);
h("gg", I, te);
h("GGGG", ws, ps);
h("gggg", ws, ps);
h("GGGGG", Ft, Pt);
h("ggggg", Ft, Pt);
mt(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, s, r) {
    t[r.substr(0, 2)] = x(e);
  }
);
mt(["gg", "GG"], function(e, t, s, r) {
  t[r] = c.parseTwoDigitYear(e);
});
function Ao(e) {
  return Jr.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Uo(e) {
  return Jr.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Ho() {
  return be(this.year(), 1, 4);
}
function Go() {
  return be(this.isoWeekYear(), 1, 4);
}
function zo() {
  var e = this.localeData()._week;
  return be(this.year(), e.dow, e.doy);
}
function Vo() {
  var e = this.localeData()._week;
  return be(this.weekYear(), e.dow, e.doy);
}
function Jr(e, t, s, r, n) {
  var a;
  return e == null ? ut(this, r, n).year : (a = be(e, r, n), t > a && (t = a), $o.call(this, e, t, s, r, n));
}
function $o(e, t, s, r, n) {
  var a = Yr(e, t, s, r, n), i = lt(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
_("Q", 0, "Qo", "quarter");
Z("quarter", "Q");
B("quarter", 7);
h("Q", pr);
Y("Q", function(e, t) {
  t[ve] = (x(e) - 1) * 3;
});
function Zo(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
_("D", ["DD", 2], "Do", "date");
Z("date", "D");
B("date", 9);
h("D", I);
h("DD", I, te);
h("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
Y(["D", "DD"], he);
Y("Do", function(e, t) {
  t[he] = x(e.match(I)[0]);
});
var Xr = qe("Date", !0);
_("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Z("dayOfYear", "DDD");
B("dayOfYear", 4);
h("DDD", jt);
h("DDDD", wr);
Y(["DDD", "DDDD"], function(e, t, s) {
  s._dayOfYear = x(e);
});
function Bo(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
_("m", ["mm", 2], 0, "minute");
Z("minute", "m");
B("minute", 14);
h("m", I);
h("mm", I, te);
Y(["m", "mm"], oe);
var qo = qe("Minutes", !1);
_("s", ["ss", 2], 0, "second");
Z("second", "s");
B("second", 15);
h("s", I);
h("ss", I, te);
Y(["s", "ss"], xe);
var Jo = qe("Seconds", !1);
_("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
_(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
_(0, ["SSS", 3], 0, "millisecond");
_(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
_(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
_(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
_(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
_(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
_(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Z("millisecond", "ms");
B("millisecond", 16);
h("S", jt, pr);
h("SS", jt, te);
h("SSS", jt, wr);
var Ee, Kr;
for (Ee = "SSSS"; Ee.length <= 9; Ee += "S")
  h(Ee, Je);
function Xo(e, t) {
  t[je] = x(("0." + e) * 1e3);
}
for (Ee = "S"; Ee.length <= 9; Ee += "S")
  Y(Ee, Xo);
Kr = qe("Milliseconds", !1);
_("z", 0, 0, "zoneAbbr");
_("zz", 0, 0, "zoneName");
function Ko() {
  return this._isUTC ? "UTC" : "";
}
function Qo() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var l = ft.prototype;
l.add = zi;
l.calendar = Xi;
l.clone = Ki;
l.diff = ao;
l.endOf = yo;
l.format = uo;
l.from = co;
l.fromNow = fo;
l.to = ho;
l.toNow = mo;
l.get = ea;
l.invalidAt = Mo;
l.isAfter = Qi;
l.isBefore = eo;
l.isBetween = to;
l.isSame = so;
l.isSameOrAfter = ro;
l.isSameOrBefore = no;
l.isValid = bo;
l.lang = Vr;
l.locale = zr;
l.localeData = $r;
l.max = xi;
l.min = vi;
l.parsingFlags = ko;
l.set = ta;
l.startOf = _o;
l.subtract = Vi;
l.toArray = wo;
l.toObject = vo;
l.toDate = po;
l.toISOString = oo;
l.inspect = lo;
typeof Symbol < "u" && Symbol.for != null && (l[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
l.toJSON = xo;
l.toString = io;
l.unix = So;
l.valueOf = go;
l.creationData = Do;
l.eraName = Eo;
l.eraNarrow = Ro;
l.eraAbbr = No;
l.eraYear = Io;
l.year = Tr;
l.isLeapYear = wa;
l.weekYear = Ao;
l.isoWeekYear = Uo;
l.quarter = l.quarters = Zo;
l.month = Dr;
l.daysInMonth = ga;
l.week = l.weeks = Da;
l.isoWeek = l.isoWeeks = Oa;
l.weeksInYear = zo;
l.weeksInWeekYear = Vo;
l.isoWeeksInYear = Ho;
l.isoWeeksInISOWeekYear = Go;
l.date = Xr;
l.day = l.days = Aa;
l.weekday = Ua;
l.isoWeekday = Ha;
l.dayOfYear = Bo;
l.hour = l.hours = qa;
l.minute = l.minutes = qo;
l.second = l.seconds = Jo;
l.millisecond = l.milliseconds = Kr;
l.utcOffset = Ri;
l.utc = Ii;
l.local = Ci;
l.parseZone = Pi;
l.hasAlignedHourOffset = ji;
l.isDST = Fi;
l.isLocal = Wi;
l.isUtcOffset = Ai;
l.isUtc = Ar;
l.isUTC = Ar;
l.zoneAbbr = Ko;
l.zoneName = Qo;
l.dates = ne(
  "dates accessor is deprecated. Use date instead.",
  Xr
);
l.months = ne(
  "months accessor is deprecated. Use month instead",
  Dr
);
l.years = ne(
  "years accessor is deprecated. Use year instead",
  Tr
);
l.zone = ne(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Ni
);
l.isDSTShifted = ne(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Li
);
function el(e) {
  return N(e * 1e3);
}
function tl() {
  return N.apply(null, arguments).parseZone();
}
function Qr(e) {
  return e;
}
var M = ys.prototype;
M.calendar = An;
M.longDateFormat = zn;
M.invalidDate = $n;
M.ordinal = qn;
M.preparse = Qr;
M.postformat = Qr;
M.relativeTime = Xn;
M.pastFuture = Kn;
M.set = Ln;
M.eras = Oo;
M.erasParse = To;
M.erasConvertYear = Yo;
M.erasAbbrRegex = Po;
M.erasNameRegex = Co;
M.erasNarrowRegex = jo;
M.months = ha;
M.monthsShort = ma;
M.monthsParse = ya;
M.monthsRegex = pa;
M.monthsShortRegex = Sa;
M.week = xa;
M.firstDayOfYear = Ma;
M.firstDayOfWeek = ka;
M.weekdays = Pa;
M.weekdaysMin = Fa;
M.weekdaysShort = ja;
M.weekdaysParse = Wa;
M.weekdaysRegex = Ga;
M.weekdaysShortRegex = za;
M.weekdaysMinRegex = Va;
M.isPM = Za;
M.meridiem = Ja;
function Rt(e, t, s, r) {
  var n = Me(), a = ye().set(r, t);
  return n[s](a, e);
}
function en(e, t, s) {
  if (ke(e) && (t = e, e = void 0), e = e || "", t != null)
    return Rt(e, t, s, "month");
  var r, n = [];
  for (r = 0; r < 12; r++)
    n[r] = Rt(e, r, s, "month");
  return n;
}
function Ns(e, t, s, r) {
  typeof e == "boolean" ? (ke(t) && (s = t, t = void 0), t = t || "") : (t = e, s = t, e = !1, ke(t) && (s = t, t = void 0), t = t || "");
  var n = Me(), a = e ? n._week.dow : 0, i, d = [];
  if (s != null)
    return Rt(t, (s + a) % 7, r, "day");
  for (i = 0; i < 7; i++)
    d[i] = Rt(t, (i + a) % 7, r, "day");
  return d;
}
function sl(e, t) {
  return en(e, t, "months");
}
function rl(e, t) {
  return en(e, t, "monthsShort");
}
function nl(e, t, s) {
  return Ns(e, t, s, "weekdays");
}
function al(e, t, s) {
  return Ns(e, t, s, "weekdaysShort");
}
function il(e, t, s) {
  return Ns(e, t, s, "weekdaysMin");
}
Re("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, s = x(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + s;
  }
});
c.lang = ne(
  "moment.lang is deprecated. Use moment.locale instead.",
  Re
);
c.langData = ne(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Me
);
var pe = Math.abs;
function ol() {
  var e = this._data;
  return this._milliseconds = pe(this._milliseconds), this._days = pe(this._days), this._months = pe(this._months), e.milliseconds = pe(e.milliseconds), e.seconds = pe(e.seconds), e.minutes = pe(e.minutes), e.hours = pe(e.hours), e.months = pe(e.months), e.years = pe(e.years), this;
}
function tn(e, t, s, r) {
  var n = de(t, s);
  return e._milliseconds += r * n._milliseconds, e._days += r * n._days, e._months += r * n._months, e._bubble();
}
function ll(e, t) {
  return tn(this, e, t, 1);
}
function ul(e, t) {
  return tn(this, e, t, -1);
}
function Js(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function dl() {
  var e = this._milliseconds, t = this._days, s = this._months, r = this._data, n, a, i, d, f;
  return e >= 0 && t >= 0 && s >= 0 || e <= 0 && t <= 0 && s <= 0 || (e += Js(os(s) + t) * 864e5, t = 0, s = 0), r.milliseconds = e % 1e3, n = re(e / 1e3), r.seconds = n % 60, a = re(n / 60), r.minutes = a % 60, i = re(a / 60), r.hours = i % 24, t += re(i / 24), f = re(sn(t)), s += f, t -= Js(os(f)), d = re(s / 12), s %= 12, r.days = t, r.months = s, r.years = d, this;
}
function sn(e) {
  return e * 4800 / 146097;
}
function os(e) {
  return e * 146097 / 4800;
}
function cl(e) {
  if (!this.isValid())
    return NaN;
  var t, s, r = this._milliseconds;
  if (e = ae(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, s = this._months + sn(t), e) {
      case "month":
        return s;
      case "quarter":
        return s / 3;
      case "year":
        return s / 12;
    }
  else
    switch (t = this._days + Math.round(os(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function fl() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + x(this._months / 12) * 31536e6 : NaN;
}
function De(e) {
  return function() {
    return this.as(e);
  };
}
var hl = De("ms"), ml = De("s"), _l = De("m"), yl = De("h"), gl = De("d"), Sl = De("w"), pl = De("M"), wl = De("Q"), vl = De("y");
function xl() {
  return de(this);
}
function bl(e) {
  return e = ae(e), this.isValid() ? this[e + "s"]() : NaN;
}
function We(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var kl = We("milliseconds"), Ml = We("seconds"), Dl = We("minutes"), Ol = We("hours"), Tl = We("days"), Yl = We("months"), El = We("years");
function Rl() {
  return re(this.days() / 7);
}
var we = Math.round, Ve = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Nl(e, t, s, r, n) {
  return n.relativeTime(t || 1, !!s, e, r);
}
function Il(e, t, s, r) {
  var n = de(e).abs(), a = we(n.as("s")), i = we(n.as("m")), d = we(n.as("h")), f = we(n.as("d")), m = we(n.as("M")), p = we(n.as("w")), w = we(n.as("y")), D = a <= s.ss && ["s", a] || a < s.s && ["ss", a] || i <= 1 && ["m"] || i < s.m && ["mm", i] || d <= 1 && ["h"] || d < s.h && ["hh", d] || f <= 1 && ["d"] || f < s.d && ["dd", f];
  return s.w != null && (D = D || p <= 1 && ["w"] || p < s.w && ["ww", p]), D = D || m <= 1 && ["M"] || m < s.M && ["MM", m] || w <= 1 && ["y"] || ["yy", w], D[2] = t, D[3] = +e > 0, D[4] = r, Nl.apply(null, D);
}
function Cl(e) {
  return e === void 0 ? we : typeof e == "function" ? (we = e, !0) : !1;
}
function Pl(e, t) {
  return Ve[e] === void 0 ? !1 : t === void 0 ? Ve[e] : (Ve[e] = t, e === "s" && (Ve.ss = t - 1), !0);
}
function jl(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var s = !1, r = Ve, n, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (s = e), typeof t == "object" && (r = Object.assign({}, Ve, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), n = this.localeData(), a = Il(this, !s, r, n), s && (a = n.pastFuture(+this, a)), n.postformat(a);
}
var Qt = Math.abs;
function Ge(e) {
  return (e > 0) - (e < 0) || +e;
}
function zt() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Qt(this._milliseconds) / 1e3, t = Qt(this._days), s = Qt(this._months), r, n, a, i, d = this.asSeconds(), f, m, p, w;
  return d ? (r = re(e / 60), n = re(r / 60), e %= 60, r %= 60, a = re(s / 12), s %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", f = d < 0 ? "-" : "", m = Ge(this._months) !== Ge(d) ? "-" : "", p = Ge(this._days) !== Ge(d) ? "-" : "", w = Ge(this._milliseconds) !== Ge(d) ? "-" : "", f + "P" + (a ? m + a + "Y" : "") + (s ? m + s + "M" : "") + (t ? p + t + "D" : "") + (n || r || e ? "T" : "") + (n ? w + n + "H" : "") + (r ? w + r + "M" : "") + (e ? w + i + "S" : "")) : "P0D";
}
var b = Ht.prototype;
b.isValid = Oi;
b.abs = ol;
b.add = ll;
b.subtract = ul;
b.as = cl;
b.asMilliseconds = hl;
b.asSeconds = ml;
b.asMinutes = _l;
b.asHours = yl;
b.asDays = gl;
b.asWeeks = Sl;
b.asMonths = pl;
b.asQuarters = wl;
b.asYears = vl;
b.valueOf = fl;
b._bubble = dl;
b.clone = xl;
b.get = bl;
b.milliseconds = kl;
b.seconds = Ml;
b.minutes = Dl;
b.hours = Ol;
b.days = Tl;
b.weeks = Rl;
b.months = Yl;
b.years = El;
b.humanize = jl;
b.toISOString = zt;
b.toString = zt;
b.toJSON = zt;
b.locale = zr;
b.localeData = $r;
b.toIsoString = ne(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  zt
);
b.lang = Vr;
_("X", 0, 0, "unix");
_("x", 0, 0, "valueOf");
h("x", Lt);
h("X", ra);
Y("X", function(e, t, s) {
  s._d = new Date(parseFloat(e) * 1e3);
});
Y("x", function(e, t, s) {
  s._d = new Date(x(e));
});
//! moment.js
c.version = "2.29.4";
jn(N);
c.fn = l;
c.min = bi;
c.max = ki;
c.now = Mi;
c.utc = ye;
c.unix = el;
c.months = sl;
c.isDate = ct;
c.locale = Re;
c.invalid = It;
c.duration = de;
c.isMoment = ue;
c.weekdays = nl;
c.parseZone = tl;
c.localeData = Me;
c.isDuration = wt;
c.monthsShort = rl;
c.weekdaysMin = il;
c.defineLocale = ks;
c.updateLocale = ei;
c.locales = ti;
c.weekdaysShort = al;
c.normalizeUnits = ae;
c.relativeTimeRounding = Cl;
c.relativeTimeThreshold = Pl;
c.calendarFormat = Ji;
c.prototype = l;
c.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const rn = (e) => {
  const { pageNumber: t, pageSize: s, sortBy: r, query: n } = e, a = Mn(r), i = `/analysis-submissions/list?size=${s || ""}&page=${t || ""}&sort=${a}&${n || ""}`;
  return _e.get(i);
}, Fl = (e) => {
  const t = `/analysis-submissions/filter?${e}`;
  return _e.get(t);
}, Ll = (e) => _e.delete(`/submissions/${e}`), Wl = (e) => _e.post("/datanode/analyses", e), Al = () => _e.get("/analysis-submissions/sorts"), Ul = (e) => _e.post("/tempfiles ", e), Hl = (e) => _e.get(`/tempfiles/${e}/metadata `), Gl = () => _e.get("/datanode/descriptors/list"), zl = (e) => _e.post(`datanode/analyses/${e}/cancel`), Vl = (e) => _e.get(`/analysis-submissions/${e}/log`), nn = (e, t) => e.find((r) => r.value === t), xt = {
  rowId: "id",
  iconName: "library",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createEntityModal: {
    name: "create-cdm",
    title: "Create submission",
    createMethodApi: (e, t) => Dn(
      e,
      t,
      Wl
    )
  },
  createCrudMethod: (e, t) => Yn(
    e,
    t,
    rn,
    Ll
  ),
  createFiltersPanel: () => Tn(null, null, Fl),
  createSortingMethod() {
    return On(null, { getSorting: Al });
  },
  getCols: ({
    t: e,
    cancelJob: t,
    canceledJobs: s
  }) => [
    {
      header: e("tables.cols.shortcut"),
      accessorKey: "shortcut",
      id: "shortcut",
      size: 80
    },
    {
      header: e("tables.cols.origin"),
      accessorKey: "origin",
      id: "origin",
      size: 80,
      cell: (r) => nn(cr, r.getValue()).name
    },
    {
      header: e("tables.cols.author"),
      accessorFn: (r) => {
        var n;
        return ((n = r.created) == null ? void 0 : n.user.name) || "-";
      },
      id: "created.user.name"
    },
    {
      header: e("tables.cols.analysis"),
      accessorFn: (r) => r.analysisTitle || "-",
      id: "analysisId",
      size: 200,
      cell: _n
    },
    {
      header: e("tables.cols.data_source"),
      accessorKey: "dataSourceTitle",
      id: "dataSource",
      size: 170
    },
    {
      header: e("tables.cols.submitted"),
      accessorKey: "submitted",
      id: "created.timestamp",
      cell: Fs,
      size: 152
    },
    {
      header: e("tables.cols.finished"),
      accessorKey: "finished",
      id: "modified.timestamp",
      cell: (r) => r.getValue() ? /* @__PURE__ */ o.jsx(Fs, { ...r }) : "-",
      size: 152
    },
    {
      header: e("tables.cols.duration", "Duration"),
      accessorKey: "finished",
      id: "duration",
      enableSorting: !1,
      cell: (r) => {
        if (r.getValue()) {
          const n = c(r.row.original.submitted), a = c(r.row.original.finished);
          return c.duration(a.diff(n)).humanize();
        } else
          return /* @__PURE__ */ o.jsx(o.Fragment, { children: "-" });
      },
      size: 100
    },
    {
      header: e("tables.cols.status"),
      accessorKey: "stage",
      id: "stage",
      minSize: 120,
      size: 120,
      cell: (r) => {
        var d, f, m, p;
        const n = (f = (d = r == null ? void 0 : r.row) == null ? void 0 : d.original) == null ? void 0 : f.stage, a = (p = (m = r == null ? void 0 : r.row) == null ? void 0 : m.original) == null ? void 0 : p.error, i = ir(n, a);
        return /* @__PURE__ */ o.jsx(ur, { text: i.name, color: i.color });
      }
    },
    {
      header: e("tables.cols.results"),
      accessorKey: "status",
      id: "actionCell",
      size: 65,
      enableResizing: !1,
      enableHiding: !1,
      meta: {
        columnType: "action"
      },
      cell: (r) => {
        var f, m, p, w, D, O, q, W;
        const n = (m = (f = r == null ? void 0 : r.row) == null ? void 0 : f.original) == null ? void 0 : m.id, a = (w = (p = r == null ? void 0 : r.row) == null ? void 0 : p.original) == null ? void 0 : w.stage, i = (O = (D = r == null ? void 0 : r.row) == null ? void 0 : D.original) == null ? void 0 : O.error;
        return ((W = (q = r == null ? void 0 : r.row.original) == null ? void 0 : q.actions) == null ? void 0 : W.download) && (i || a === se.COMPLETED || a === se.FAILED) ? /* @__PURE__ */ o.jsx(Ws, { text: e("tooltips.download_results"), children: /* @__PURE__ */ o.jsx(
          As,
          {
            color: "info",
            onClick: (X) => {
              X.stopPropagation(), window.location.href = `/api/datanode/submissions/${n}/results/download`;
            },
            sx: { my: -1 },
            children: /* @__PURE__ */ o.jsx(it, { iconName: "import", fontSize: "small" })
          }
        ) }) : /* @__PURE__ */ o.jsx(o.Fragment, {});
      }
    },
    {
      header: "",
      accessorKey: "id",
      id: "cancelCell",
      enableHiding: !1,
      meta: {
        columnType: "action"
      },
      size: 40,
      cell: (r) => {
        var f, m, p, w, D, O, q;
        const n = (m = (f = r == null ? void 0 : r.row) == null ? void 0 : f.original) == null ? void 0 : m.id, a = (w = (p = r == null ? void 0 : r.row) == null ? void 0 : p.original) == null ? void 0 : w.stage, i = (O = (D = r == null ? void 0 : r.row) == null ? void 0 : D.original) == null ? void 0 : O.error;
        return !(((q = s()) == null ? void 0 : q.includes(n)) || i || a === se.COMPLETED || a === se.ABORTED) && /* @__PURE__ */ o.jsx(Ws, { text: "Cancel job", children: /* @__PURE__ */ o.jsx(
          As,
          {
            color: "error",
            onClick: (W) => {
              W.stopPropagation(), t(n);
            },
            size: "small",
            sx: { my: -1, ml: -1 },
            children: /* @__PURE__ */ o.jsx(it, { iconName: "close", fontSize: "small" })
          }
        ) });
      }
    }
  ]
}, $l = (e, t) => [
  {
    value: Te.FILES_IN_ARCHIVE,
    title: e("modals.create_submission.tabs.files_archive"),
    onTabClick: t
  },
  {
    value: Te.SEPARATE_FILES,
    title: e("modals.create_submission.tabs.separate_files"),
    onTabClick: t
  }
];
Ie.div`
  font-size: 12px;
  font-weight: 300;
  padding: 5px 5px;
  border-bottom: 1px solid #232323;
  margin: 0px 10px 0px 0px;
  cursor: pointer;

  &.active {
    font-weight: 700;
  }
  &:hover {
    background: #e1e1e1;
  }
`;
Ie.div`
  height: 500px;
  overflow-y: auto;
`;
const Zl = Ie.div`
  position: absolute;
  width: 700px;
  height: calc(100vh - 60px);
  top: 0;
  right: 0;
  background: #eff8fd96;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  z-index: 1000;
`, Xs = {
  dataSourceId: "",
  title: "",
  analysisType: "",
  analysisTitle: "",
  studyId: "",
  studyName: "",
  executableFileName: "",
  runtimeEnvironmentId: "",
  fileIds: ""
}, an = er((e) => {
  const { parentId: t, afterCreate: s, onCancel: r, createMethod: n, subModules: a, t: i } = e, [d, f] = Q(!1), [m, p] = Q([]), [w, D] = Q(U.INITIAL), [O, q] = Q([]), [W, X] = Q(), [g, E] = Q(Xs), [T, ie] = Q(
    Te.FILES_IN_ARCHIVE
  );
  Ne(() => {
    Gl().then((y) => {
      q(
        y.content.map((j) => ({
          name: j.label,
          value: j.id
        }))
      );
    });
  }, []), Ne(() => {
    E(Xs);
  }, [T]);
  const Ae = bt(() => {
    f(!0), n(g).then((y) => {
      f(!1), s == null || s(y);
    });
  }, [t, g, n]), Ue = kt(() => {
    if (T === Te.FILES_IN_ARCHIVE)
      return g.fileIds && g.dataSourceId && g.analysisType && g.executableFileName;
    if (T === Te.SEPARATE_FILES)
      return g.fileIds && g.dataSourceId && g.analysisType;
  }, [g, T]), Ce = bt(
    async (y, j) => {
      var L, K, _t;
      D(U.IN_PROGRESS);
      let G = new FormData();
      G.append("file", y);
      try {
        const ce = await Ul(G);
        if (T === Te.FILES_IN_ARCHIVE)
          try {
            const A = await Hl(ce[0]);
            E({
              ...g,
              analysisType: A == null ? void 0 : A.analysisType,
              analysisTitle: A == null ? void 0 : A.analysisName,
              studyName: A == null ? void 0 : A.studyName,
              executableFileName: A == null ? void 0 : A.entryPoint,
              runtimeEnvironmentId: (A == null ? void 0 : A.runtimeEnvironmentId) || ((L = O == null ? void 0 : O[0]) == null ? void 0 : L.value),
              fileIds: ce
            }), D(U.SUCCESS);
          } catch {
            E({
              ...g,
              runtimeEnvironmentId: g.runtimeEnvironmentId || ((K = O == null ? void 0 : O[0]) == null ? void 0 : K.value),
              fileIds: ce,
              analysisTitle: j
            }), D(U.SUCCESS);
          }
        else
          E({
            ...g,
            runtimeEnvironmentId: g.runtimeEnvironmentId || ((_t = O == null ? void 0 : O[0]) == null ? void 0 : _t.value),
            fileIds: ce,
            analysisType: Hs.STRATEGUS
          }), D(U.SUCCESS);
      } catch (ce) {
        D(U.ERROR), console.log(ce);
      }
    },
    [T, g, O]
  );
  return /* @__PURE__ */ o.jsxs(R, { container: !0, children: [
    /* @__PURE__ */ o.jsx(fs, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ o.jsx(rr, { tabs: $l(i, ie), active: T }) }),
    /* @__PURE__ */ o.jsxs(R, { container: !0, p: 2, children: [
      w === U.IN_PROGRESS && /* @__PURE__ */ o.jsx(Zl, { children: /* @__PURE__ */ o.jsx(ot, { size: 50 }) }),
      /* @__PURE__ */ o.jsx(dr, { children: /* @__PURE__ */ o.jsxs(R, { item: !0, container: !0, xs: 12, p: 2, spacing: 2, children: [
        T === Te.FILES_IN_ARCHIVE && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            a.documents,
            {
              type: "component",
              name: "import-zip-file",
              subModules: a,
              config: {
                titleButton: i("buttons.upload_zip"),
                onChange: (y, j) => {
                  const G = Object.keys(y.files).map((K) => y.files[K]).filter((K) => K.name.toLowerCase().includes(".sql") || K.name.toLowerCase().includes(".r")).map((K) => ({
                    name: K.name,
                    value: K.name
                  }));
                  p(G);
                  const L = j.name.split(".");
                  L.pop(), E({
                    ...g,
                    analysisTitle: L.join()
                  }), X(j), Ce(j, L.join());
                }
              }
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "type",
              textLabel: i("forms.entry_point"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                Xe,
                {
                  className: "",
                  name: "entry-point",
                  disablePortal: !0,
                  id: "entry point",
                  options: m,
                  value: g.executableFileName,
                  placeholder: i("forms.entry_point_placeholder"),
                  onChange: (y) => {
                    E({
                      ...g,
                      executableFileName: y
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "env",
              textLabel: i("forms.runtime_env"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                Xe,
                {
                  className: "",
                  name: "env",
                  disablePortal: !0,
                  id: "env",
                  options: O,
                  value: g.runtimeEnvironmentId,
                  placeholder: i("forms.runtime_env_placeholder"),
                  onChange: (y) => {
                    E({
                      ...g,
                      runtimeEnvironmentId: y
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            a.dataSources,
            {
              type: "component",
              name: "data-sources-list-select",
              subModules: a,
              config: {
                onChange: (y) => {
                  E({
                    ...g,
                    dataSourceId: y
                  });
                }
              }
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "analysis-name",
              textLabel: i("forms.analysis_name"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                yt,
                {
                  id: "analysis-name",
                  name: "analysis-name",
                  type: "text",
                  size: "medium",
                  placeholder: i("forms.analysis_name_placeholder"),
                  value: g.analysisTitle,
                  onChange: (y) => {
                    E({
                      ...g,
                      analysisTitle: y.target.value
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "type",
              textLabel: i("forms.analysis_type"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                Xe,
                {
                  className: "",
                  name: "type",
                  disablePortal: !0,
                  id: "type",
                  options: Gs,
                  value: g.analysisType,
                  placeholder: i("forms.analysis_type_placeholder"),
                  onChange: (y) => {
                    E({
                      ...g,
                      analysisType: y
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "study-name",
              textLabel: i("forms.study_name"),
              children: /* @__PURE__ */ o.jsx(
                yt,
                {
                  id: "study-name",
                  name: "study-name",
                  type: "text",
                  size: "medium",
                  placeholder: i("forms.study_name_placeholder"),
                  value: g.studyName,
                  onChange: (y) => {
                  },
                  fullWidth: !0
                }
              )
            }
          ) })
        ] }),
        T === Te.SEPARATE_FILES && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            a.documents,
            {
              type: "component",
              name: "import-json-file",
              subModules: a,
              config: {
                titleButton: i("buttons.upload_json"),
                onChange: (y, j) => {
                  Ce(j);
                }
              }
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "env",
              textLabel: i("forms.runtime_env"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                Xe,
                {
                  className: "",
                  name: "env",
                  disablePortal: !0,
                  id: "env",
                  options: O,
                  value: g.runtimeEnvironmentId,
                  placeholder: i("forms.runtime_env_placeholder"),
                  onChange: (y) => {
                    E({
                      ...g,
                      runtimeEnvironmentId: y
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            a.dataSources,
            {
              type: "component",
              name: "data-sources-list-select",
              subModules: a,
              config: {
                onChange: (y) => {
                  E({
                    ...g,
                    dataSourceId: y
                  });
                }
              }
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "analysis-name",
              textLabel: i("forms.analysis_name"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                yt,
                {
                  id: "analysis-name",
                  name: "analysis-name",
                  type: "text",
                  size: "medium",
                  placeholder: i("forms.analysis_name_placeholder"),
                  value: g.analysisTitle,
                  onChange: (y) => {
                    E({
                      ...g,
                      analysisTitle: y.target.value
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "type",
              textLabel: i("forms.analysis_type"),
              required: !0,
              children: /* @__PURE__ */ o.jsx(
                Xe,
                {
                  className: "",
                  name: "type",
                  disablePortal: !0,
                  id: "type",
                  disabled: !0,
                  options: Gs,
                  value: Hs.STRATEGUS,
                  placeholder: i("forms.analysis_type_placeholder"),
                  onChange: (y) => {
                    E({
                      ...g,
                      analysisType: y
                    });
                  },
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
            Se,
            {
              name: "study-name",
              textLabel: i("forms.study_name"),
              children: /* @__PURE__ */ o.jsx(
                yt,
                {
                  id: "study-name",
                  name: "study-name",
                  type: "text",
                  size: "medium",
                  value: g.studyName,
                  placeholder: i("forms.study_name_placeholder"),
                  onChange: (y) => {
                  },
                  fullWidth: !0
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsxs(yn, { children: [
          /* @__PURE__ */ o.jsx(
            Mt,
            {
              variant: "outlined",
              disabled: d,
              onClick: r,
              startIcon: /* @__PURE__ */ o.jsx(it, { iconName: "deactivate" }),
              children: i("buttons.cancel")
            }
          ),
          /* @__PURE__ */ o.jsx(
            Mt,
            {
              disabled: d || !Ue,
              onClick: Ae,
              variant: "contained",
              color: "success",
              startIcon: d ? /* @__PURE__ */ o.jsx(ot, { size: 16 }) : /* @__PURE__ */ o.jsx(it, { iconName: "submit" }),
              children: i("buttons.create")
            }
          )
        ] }) })
      ] }) })
    ] })
  ] });
}), Bl = Ie("div")(({ theme: e }) => ({
  fontSize: 15,
  fontWeight: "bold",
  color: e == null ? void 0 : e.palette.textColor.header
})), on = Ie("div")(
  ({ theme: e }) => ({
    display: "flex",
    flexDirection: "column",
    fontSize: 24,
    fontWeight: 300,
    paddingBottom: 0
  })
), Nt = Ie.div`
  font-size: ${(e) => e.smallFont ? "12px" : "24px"};
  /* margin-left: 10px; */
`, ql = (e) => {
  var i;
  const { t } = e, s = lr(), {
    data: r,
    status: n,
    getEntityList: a
  } = bn({
    methods: {
      read: {
        method: () => rn({
          sortBy: { id: "modified.timestamp", desc: !0 }
        })
      }
    }
  });
  return Ne(() => {
    a();
  }, [a]), n === U.INITIAL || n === U.IN_PROGRESS || n === U.IN_PROGRESS_RELOAD ? /* @__PURE__ */ o.jsx(cs, { children: /* @__PURE__ */ o.jsx(ot, { size: 32 }) }) : /* @__PURE__ */ o.jsxs(R, { container: !0, children: [
    /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(Bl, { children: t("modules.submissions.latest_submissions") }) }),
    /* @__PURE__ */ o.jsxs(gn, { children: [
      n === U.SUCCESS && ((i = Object.values(r.byId)) != null && i.length ? Object.values(r.byId).slice(0, 5).map((d) => {
        const f = ir(d.stage, d.error), m = nn(
          cr,
          d.origin
        );
        return /* @__PURE__ */ o.jsxs(
          Bt,
          {
            onClick: () => {
              e.openSubmission(d);
            },
            children: [
              /* @__PURE__ */ o.jsxs("div", { className: "list-item-section nowrap", children: [
                /* @__PURE__ */ o.jsxs("div", { className: "list-item-title", children: [
                  d.analysisTitle,
                  " "
                ] }),
                /* @__PURE__ */ o.jsx(
                  Nn,
                  {
                    sx: {
                      fontWeight: 300,
                      color: "#654774",
                      whiteSpace: "nowrap",
                      pr: 1
                    },
                    children: `[ ${m.name} ]`
                  }
                )
              ] }),
              f && /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(ur, { text: f.name, color: f.color }) })
            ]
          },
          d.id + "favorite"
        );
      }) : /* @__PURE__ */ o.jsx(Bt, { light: !0, children: /* @__PURE__ */ o.jsx(
        Us,
        {
          noDataText: t("modules.submissions.no_data_text"),
          addButtonText: t("modules.submissions.go_to"),
          onAdd: () => s("/submissions")
        }
      ) })),
      n === U.ERROR && /* @__PURE__ */ o.jsx(Bt, { light: !0, children: /* @__PURE__ */ o.jsx(
        Us,
        {
          noDataText: t("modules.submissions.failed_load"),
          addButtonText: ""
        }
      ) })
    ] })
  ] });
}, Jl = (e, t, s, r) => {
  var a, i, d, f;
  const n = [s, {
    code: t,
    ...r || {}
  }];
  if ((i = (a = e == null ? void 0 : e.services) == null ? void 0 : a.logger) != null && i.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  Le(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), (f = (d = e == null ? void 0 : e.services) == null ? void 0 : d.logger) != null && f.warn ? e.services.logger.warn(...n) : console != null && console.warn && console.warn(...n);
}, Ks = {}, ls = (e, t, s, r) => {
  Le(s) && Ks[s] || (Le(s) && (Ks[s] = /* @__PURE__ */ new Date()), Jl(e, t, s, r));
}, ln = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const s = () => {
      setTimeout(() => {
        e.off("initialized", s);
      }, 0), t();
    };
    e.on("initialized", s);
  }
}, us = (e, t, s) => {
  e.loadNamespaces(t, ln(e, s));
}, Qs = (e, t, s, r) => {
  if (Le(s) && (s = [s]), e.options.preload && e.options.preload.indexOf(t) > -1) return us(e, s, r);
  s.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(t, ln(e, r));
}, Xl = (e, t, s = {}) => !t.languages || !t.languages.length ? (ls(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: s.lng,
  precheck: (r, n) => {
    if (s.bindI18n && s.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !n(r.isLanguageChangingTo, e)) return !1;
  }
}), Le = (e) => typeof e == "string", Kl = (e) => typeof e == "object" && e !== null, Ql = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, eu = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, tu = (e) => eu[e], su = (e) => e.replace(Ql, tu);
let ru = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: su
};
const nu = () => ru;
let au;
const iu = () => au, ou = tr();
class lu {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((s) => {
      this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const uu = (e, t) => {
  const s = sr();
  return Ne(() => {
    s.current = e;
  }, [e, t]), s.current;
}, un = (e, t, s, r) => e.getFixedT(t, s, r), du = (e, t, s, r) => bt(un(e, t, s, r), [e, t, s, r]), dn = (e, t = {}) => {
  var ie, Ae, Ue, Ce;
  const {
    i18n: s
  } = t, {
    i18n: r,
    defaultNS: n
  } = st(ou) || {}, a = s || r || iu();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new lu()), !a) {
    ls(a, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const y = (G, L) => Le(L) ? L : Kl(L) && Le(L.defaultValue) ? L.defaultValue : Array.isArray(G) ? G[G.length - 1] : G, j = [y, {}, !1];
    return j.t = y, j.i18n = {}, j.ready = !1, j;
  }
  (ie = a.options.react) != null && ie.wait && ls(a, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...nu(),
    ...a.options.react,
    ...t
  }, {
    useSuspense: d,
    keyPrefix: f
  } = i;
  let m = n || ((Ae = a.options) == null ? void 0 : Ae.defaultNS);
  m = Le(m) ? [m] : m || ["translation"], (Ce = (Ue = a.reportNamespaces).addUsedNamespaces) == null || Ce.call(Ue, m);
  const p = (a.isInitialized || a.initializedStoreOnce) && m.every((y) => Xl(y, a, i)), w = du(a, t.lng || null, i.nsMode === "fallback" ? m : m[0], f), D = () => w, O = () => un(a, t.lng || null, i.nsMode === "fallback" ? m : m[0], f), [q, W] = Q(D);
  let X = m.join();
  t.lng && (X = `${t.lng}${X}`);
  const g = uu(X), E = sr(!0);
  Ne(() => {
    const {
      bindI18n: y,
      bindI18nStore: j
    } = i;
    E.current = !0, !p && !d && (t.lng ? Qs(a, t.lng, m, () => {
      E.current && W(O);
    }) : us(a, m, () => {
      E.current && W(O);
    })), p && g && g !== X && E.current && W(O);
    const G = () => {
      E.current && W(O);
    };
    return y && (a == null || a.on(y, G)), j && (a == null || a.store.on(j, G)), () => {
      E.current = !1, a && y && (y == null || y.split(" ").forEach((L) => a.off(L, G))), j && a && j.split(" ").forEach((L) => a.store.off(L, G));
    };
  }, [a, X]), Ne(() => {
    E.current && p && W(D);
  }, [a, f, p]);
  const T = [q, a, p];
  if (T.t = q, T.i18n = a, T.ready = p, p || !p && !d) return T;
  throw new Promise((y) => {
    t.lng ? Qs(a, t.lng, m, () => y()) : us(a, m, () => y());
  });
}, cu = (e, t) => [
  {
    value: rt.FILE_EXPLORER,
    title: e("modals.files_results.tabs.file_explorer", "File Explorer"),
    onTabClick: t
  },
  {
    value: rt.LOG,
    title: e("modals.files_results.tabs.logs", "Logs"),
    onTabClick: t
  }
], fu = {
  log: null,
  reloadId: null,
  status: U.INITIAL
}, hu = (e, t) => En(e, (s) => {
  switch (t.type) {
    case "GET_LOG":
      s.log ? s.status = U.IN_PROGRESS : s.status = U.IN_PROGRESS_RELOAD;
      break;
    case "GET_LOG_DONE":
      s.status = U.SUCCESS, s.log = t.payload;
      break;
    case "GET_LOG_FAILED":
      s.status = U.ERROR, s.log = null;
  }
}), mu = (e) => {
  const [t, s] = mn(hu, fu), r = async () => {
    s({
      type: "GET_LOG"
      /* GET_LOG */
    });
    try {
      const n = await Vl(e);
      s({
        type: "GET_LOG_DONE",
        payload: n.data
      });
    } catch {
      s({
        type: "GET_LOG_FAILED"
        /* GET_LOG_FEAILED */
      });
    }
  };
  return nr(() => {
    r();
  }, 1e4), Ne(() => {
    r();
  }, []), {
    ...t
  };
};
Ie.div`
  /* margin: 3px; */
`;
const _u = Ie.div`
  text-align: center;
  opacity: 0.2;
  font-size: 20px;
  margin: 100px 0;
`, yu = (e) => {
  const { itemId: t } = e, { log: s, status: r } = mu(t);
  return [U.INITIAL, U.IN_PROGRESS_RELOAD].includes(r) ? /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, py: "100px", children: /* @__PURE__ */ o.jsx(cs, { children: /* @__PURE__ */ o.jsx(ot, { size: 30 }) }) }) : /* @__PURE__ */ o.jsx(fs, { elevation: 0, sx: { p: 2 }, children: s ? /* @__PURE__ */ o.jsx(
    Sn,
    {
      data: s || "",
      height: "73vh",
      containerStyles: { padding: 0 },
      enableDownload: !0,
      enableCopy: !0,
      readOnly: !0
    }
  ) : /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(_u, { children: "No available logs" }) }) });
}, gu = (e) => {
  const t = e == null ? void 0 : e.stage, s = e == null ? void 0 : e.error;
  if ([
    se.ABORT,
    se.ABORTED,
    se.ABORT_FAILURE
  ].includes(t))
    return "No files, submission CANCELLED.";
  if (s || t === se.FAILED)
    return "No files, submission FAILED.";
  if ([
    se.PENDING,
    se.SEND,
    se.INITIALIZE,
    se.EXECUTE
  ].includes(t))
    return "No files, submission IN PROGRESS.";
}, cn = (e) => {
  const { item: t } = e, { t: s } = dn(), [r, n] = Q(
    rt.FILE_EXPLORER
  ), a = kt(() => cu(s, n), [n, s]);
  return /* @__PURE__ */ o.jsxs(R, { container: !0, children: [
    /* @__PURE__ */ o.jsx(fs, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ o.jsx(rr, { tabs: a, active: r }) }),
    /* @__PURE__ */ o.jsx(dr, { children: /* @__PURE__ */ o.jsxs(R, { item: !0, container: !0, xs: 12, p: 2, spacing: 2, children: [
      r === rt.FILE_EXPLORER && /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(
        pn,
        {
          submissionId: t.id,
          url: "datanode/submissions",
          noDataMessage: gu(t)
        }
      ) }),
      r === rt.LOG && /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ o.jsx(yu, { itemId: t.id }) })
    ] }) })
  ] });
}, Su = (e) => {
  const { t } = e, s = lr(), { openModal: r, closeModal: n } = st(ar), { createEntityModal: a } = xt, i = ds.useMemo(() => a.createMethodApi(null, null), []), d = () => {
    r(
      () => /* @__PURE__ */ o.jsx(
        an,
        {
          parentId: null,
          createMethod: i == null ? void 0 : i.create,
          subModules: e.subModules,
          onCancel: n,
          t,
          afterCreate: (m) => {
            n(), s("/submissions");
          }
        }
      ),
      t("modals.create_submission.header"),
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, f = (m) => {
    r(
      // Use the same modal as the full Submissions list (File Explorer + Log
      // tabs) so results are consistent regardless of where the submission was
      // opened from (PRO-3956).
      () => /* @__PURE__ */ o.jsx(cn, { item: m }),
      /* @__PURE__ */ o.jsxs(on, { children: [
        /* @__PURE__ */ o.jsx(Nt, { children: t("modals.result_submission_header") }),
        /* @__PURE__ */ o.jsx(Nt, { smallFont: !0, children: or(m.createdDate) })
      ] }, "modal-header"),
      {
        closeOnClickOutside: !0,
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ o.jsx(
    wn,
    {
      title: t("modules.submissions.header"),
      onClick: () => s("/submissions"),
      description: t("modules.submissions.list_submissions"),
      iconName: "library",
      actions: /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(
          Mt,
          {
            onClick: () => d(),
            variant: "contained",
            color: "success",
            name: "save",
            startIcon: /* @__PURE__ */ o.jsx(it, { iconName: "add" }),
            children: t("modules.submissions.create_submission")
          }
        ),
        /* @__PURE__ */ o.jsx(
          Mt,
          {
            onClick: () => s("/submissions"),
            variant: "outlined",
            name: "save",
            sx: { ml: 1 },
            children: t("buttons.view_all")
          }
        )
      ] }),
      children: /* @__PURE__ */ o.jsx(R, { item: !0, xs: 12, pt: 2, children: /* @__PURE__ */ o.jsx(ql, { t, openSubmission: f }) })
    }
  );
}, pu = er((e) => {
  const { name: t, config: s, ...r } = e;
  return /* @__PURE__ */ o.jsx(ds.Fragment, { children: t === "home-widget" && /* @__PURE__ */ o.jsx(Su, { ...r }) });
}), wu = () => {
  const { openModal: e, closeModal: t } = st(ar), { showDialog: s, hideDialog: r } = st(kn), { t: n } = dn(), { enqueueSnackbar: a } = In(), i = st(
    fn
  ), [d, f] = Q(), [m, p] = Q([]), w = kt(() => i == null ? void 0 : i.config, []), D = async (T) => {
    p((ie) => [...ie, T]);
    try {
      await zl(T), f(qt()), a({
        message: "Submission stoped",
        variant: "success"
      });
    } catch (ie) {
      console.log(ie), a({
        message: ie.message,
        variant: "error"
      });
    }
  }, O = (T) => {
    s(xn, {
      onSubmit: async () => {
        D(T);
      },
      onClose: r,
      text: "Are you sure you want to cancel this submission?",
      confirmButtonText: "CONFIRM",
      variant: "info"
    });
  }, { createEntityModal: q } = xt, W = kt(() => q.createMethodApi(
    w == null ? void 0 : w.typeContainer,
    w == null ? void 0 : w.parentId
  ), [w == null ? void 0 : w.typeContainer, w == null ? void 0 : w.parentId]), X = () => {
    e(
      () => /* @__PURE__ */ o.jsx(
        an,
        {
          parentId: w == null ? void 0 : w.parentId,
          createMethod: W == null ? void 0 : W.create,
          subModules: i.subModules,
          onCancel: t,
          t: i.t,
          afterCreate: (T) => {
            f(qt()), t();
          }
        }
      ),
      i.t("modals.create_submission.header"),
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: t
      }
    );
  }, g = bt((T) => {
    e(
      () => /* @__PURE__ */ o.jsx(cn, { item: T }),
      /* @__PURE__ */ o.jsxs(on, { children: [
        /* @__PURE__ */ o.jsx(Nt, { children: i.t("modals.result_submission_header") }),
        /* @__PURE__ */ o.jsx(Nt, { smallFont: !0, children: or(T.createdDate) })
      ] }, "modal-header"),
      {
        closeOnClickOutside: !0,
        onClose: t
      }
    );
  }, []), E = () => m;
  return nr(() => {
    f(qt());
  }, 1e4), /* @__PURE__ */ o.jsx(
    vn,
    {
      reloadId: d,
      isImport: !1,
      onCreate: X,
      moduleConfig: i,
      onRowClick: (T) => {
        g(T.original);
      },
      listConfig: {
        ...xt,
        loadingMessage: i.t(
          "modules.submissions.loading_submissions"
        ),
        addButtonTitle: i.t("modules.submissions.create_submission"),
        tableTitle: i.t("modules.submissions.header"),
        importButtonTitle: i.t("buttons.import"),
        cols: xt.getCols({
          t: i.t,
          cancelJob: O,
          canceledJobs: E
        })
      },
      isSilentReload: !0,
      variant: "primary"
    }
  );
}, vu = () => /* @__PURE__ */ o.jsx(o.Fragment, { children: "Entity" }), fn = tr(null), xu = (e) => {
  const { path: t, title: s, rootSettings: r } = e, [n, a] = Q(r), [i, d] = Q(!0);
  return Ne(() => {
    r || a({
      rootPath: t,
      rootTitle: s
    }), d(!1);
  }, []), i ? /* @__PURE__ */ o.jsx(cs, { children: /* @__PURE__ */ o.jsx(ot, { size: 32 }) }) : /* @__PURE__ */ o.jsx(fn.Provider, { value: { ...e, rootSettings: n }, children: /* @__PURE__ */ o.jsxs(Rn, { children: [
    /* @__PURE__ */ o.jsx(Ls, { index: !0, element: /* @__PURE__ */ o.jsx(wu, {}) }),
    /* @__PURE__ */ o.jsx(Ls, { path: ":id/*", element: /* @__PURE__ */ o.jsx(vu, {}) })
  ] }) });
}, Nu = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    !t && /* @__PURE__ */ o.jsx(xu, { ...e }),
    t === "component" && /* @__PURE__ */ o.jsx(pu, { ...e })
  ] });
};
export {
  Nu as Submissions
};
//# sourceMappingURL=submissions.js.map
